import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import { AuthContext } from '../../components/AuthContext';
import Select from 'react-select';
import Swal from 'sweetalert2';
import QRScanner from '../../components/QRScanner/QRScanner';
import QrScanner from 'qr-scanner'; // Import the actual qr-scanner library
import GSTVerificationModal from '../../components/GSTVerificationModal';
import PANVerificationModal from '../../components/PANVerificationModal';
import { 
  FaCheck, 
  FaSearch, 
  FaPlus,
  FaTrash, 
  FaFilter, 
  FaSort, 
  FaSortUp, 
  FaSortDown,
  FaTimes,
  FaUser,
  FaUserTie,
  FaBuilding,
  FaBox,
  FaEye,
  FaChartBar,
  FaSync,
  FaTag,
  FaQrcode,
  FaCamera,
  FaUsers,
  FaCubes,
  FaCalculator,
  FaRupeeSign,
  FaShoppingCart,
  FaEdit,
  FaCog,
  FaChartLine,
  FaCube,
  FaRulerCombined,
  FaExpand,
  FaRuler,
  FaMapMarkerAlt,
  FaHashtag,
  FaPercent,
  FaComment,
  FaArrowLeft,
  FaExclamationTriangle,
  FaStore,
  FaPhone,
  FaEnvelope,
  FaClipboardList
} from "react-icons/fa";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

// Custom styles for react-select
const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.5)' : 'none',
    '&:hover': {
      borderColor: '#3b82f6'
    },
    minHeight: '42px',
    borderRadius: '8px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#eff6ff' : 'white',
    color: state.isSelected ? 'white' : '#374151',
    '&:hover': {
      backgroundColor: state.isSelected ? '#3b82f6' : '#eff6ff'
    }
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#eff6ff',
    borderRadius: '6px'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#3b82f6'
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#3b82f6',
    '&:hover': {
      backgroundColor: '#3b82f6',
      color: 'white'
    }
  })
};

const ChoiceEntry = () => {
  const { user } = useContext(AuthContext);
  
  // Refs
  const searchInputRef = useRef(null);
  
  // Main data states
  const [choices, setChoices] = useState([]);
  const [guests, setGuests] = useState([]);
  const [references, setReferences] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [tallyItems, setTallyItems] = useState([]);
  
  // UI states
  const [loading, setLoading] = useState(false);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalChoices, setTotalChoices] = useState(0);
  const [itemsPerPage] = useState(20);
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  // Filter states
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [sortBy, setSortBy] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('desc');
  const [statusFilter, setStatusFilter] = useState('');
  
  // Modal states
  const [showChoiceModal, setShowChoiceModal] = useState(false);
  const [choiceModalMode, setChoiceModalMode] = useState('create'); // 'create' or 'edit'
  const [showGuestModal, setShowGuestModal] = useState(false);
  const [showReferenceModal, setShowReferenceModal] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showDealerModal, setShowDealerModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [showItemDetailsModal, setShowItemDetailsModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showCreateGuestModal, setShowCreateGuestModal] = useState(false);
  const [showCreateReferenceModal, setShowCreateReferenceModal] = useState(false);
  
  // Status management states
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [newStatus, setNewStatus] = useState('');
  const [viewingChoice, setViewingChoice] = useState(null);
  const [selectedItemForDetails, setSelectedItemForDetails] = useState(null);
  const [editingChoice, setEditingChoice] = useState(null);
  
  // Form states
  const [formData, setFormData] = useState({
    contactType: 'Guest',
    guest: null,
    reference: null,
    customer: null,
    dealer: null,
    paymentRemark: '',
    items: [{
      tallyItem: null,
      quantity: 1,
      uom: 'pcs',
      price: 0,
      pricePerSqft: 0,
      amount: 0,
      applicationArea: '',
      markup: '',
      remarks: '',
      availability: '',
      calculationType: 'pcs',
      areaValue: 0,
      areaUnit: 'sqft',
      boxQuantity: 0,
      pcsQuantity: 0
      // Removed remarkNumeric field
    }]
  });
  
  // Guest modal states
  const [guestSearch, setGuestSearch] = useState('');
  const [guestPage, setGuestPage] = useState(1);
  const [totalGuestPages, setTotalGuestPages] = useState(1);
  const [loadingGuests, setLoadingGuests] = useState(false);
  
  // Reference modal states
  const [referenceSearch, setReferenceSearch] = useState('');
  const [referencePage, setReferencePage] = useState(1);
  const [totalReferencePages, setTotalReferencePages] = useState(1);
  const [loadingReferences, setLoadingReferences] = useState(false);
  
  // Customer modal states
  const [customerSearch, setCustomerSearch] = useState('');
  const [customerPage, setCustomerPage] = useState(1);
  const [totalCustomerPages, setTotalCustomerPages] = useState(1);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  
  // Dealer modal states
  const [dealerSearch, setDealerSearch] = useState('');
  const [dealerPage, setDealerPage] = useState(1);
  const [totalDealerPages, setTotalDealerPages] = useState(1);
  const [loadingDealers, setLoadingDealers] = useState(false);
  
  // Item modal states
  const [itemSearch, setItemSearch] = useState('');
  const [itemPage, setItemPage] = useState(1);
  const [totalItemPages, setTotalItemPages] = useState(1);
  const [loadingItems, setLoadingItems] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);

  // QR Scanner states
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [qrScannerLoading, setQrScannerLoading] = useState(false);
  const [qrCodeData, setQrCodeData] = useState('');
  const [availableCameras, setAvailableCameras] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState('');
  const [cameraFacingMode, setCameraFacingMode] = useState('environment');
  const [qrScanProcessing, setQrScanProcessing] = useState(false); // Prevent multiple scans

  // QR Scanner refs
  const qrScannerRef = useRef(null);

  // Analytics states
  const [analytics, setAnalytics] = useState({
    mostCommonItems: [],
    totalChoices: 0,
    totalItems: 0,
    averageItemsPerChoice: 0
  });

  // Create guest form states
  const [newGuestForm, setNewGuestForm] = useState({
    guestName: '',
    phoneNo: '',
    secondaryPhoneNo: '',
    email: '',
    station: null,
    reference: '',
    salesperson: null
  });

  // Create reference form states
  const [newReferenceForm, setNewReferenceForm] = useState({
    name: '',
    phoneNumber: '',
    secondaryPhoneNumber: '',
    classification: '',
    type: '',
    station: ''
  });

  // Create customer form states
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
  const [newCustomerForm, setNewCustomerForm] = useState({
    name: '',
    phone: '',
    secondaryPhone: '',
    email: '',
    station: '',
    pinCode: '',
    panNo: '',
    gstNo: '',
    siteAddress: '',
    deliveryAddress: '',
    salutation: '',
    createdBy: user?.user?._id
  });
  const [isCustomerPanReadOnly, setIsCustomerPanReadOnly] = useState(false);
  const [isCustomerGstReadOnly, setIsCustomerGstReadOnly] = useState(false);
  const [showCustomerGstPanFields, setShowCustomerGstPanFields] = useState(false);
  const [showCustomerGSTVerification, setShowCustomerGSTVerification] = useState(false);
  const [showCustomerPANVerification, setShowCustomerPANVerification] = useState(false);
  const [isCreatingCustomer, setIsCreatingCustomer] = useState(false);

  // Create dealer form states
  const [showCreateDealerModal, setShowCreateDealerModal] = useState(false);
  const [newDealerForm, setNewDealerForm] = useState({
    businessName: '',
    businessOwner: '',
    phone: '',
    secondaryPhone: '',
    email: '',
    address: '',
    station: '',
    pinCode: '',
    gstNo: '',
    panNo: '',
    createdBy: user?.user?._id
  });
  const [isDealerPanReadOnly, setIsDealerPanReadOnly] = useState(false);
  const [isDealerGstReadOnly, setIsDealerGstReadOnly] = useState(false);
  const [showDealerGstPanFields, setShowDealerGstPanFields] = useState(false);
  const [showDealerGSTVerification, setShowDealerGSTVerification] = useState(false);
  const [showDealerPANVerification, setShowDealerPANVerification] = useState(false);
  const [isCreatingDealer, setIsCreatingDealer] = useState(false);

  // Additional state for redesigned modals
  const [selectedStation, setSelectedStation] = useState(null);
  const [selectedReferenceType, setSelectedReferenceType] = useState(null);

  // API Base URL
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  // Helper function to safely render any value (object, array, string, etc.)
  const safeRender = (value, fallback = 'N/A') => {
    if (value === null || value === undefined) {
      return fallback;
    }
    
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        // Handle arrays
        return value.length > 0 ? value.map(item => 
          typeof item === 'object' ? JSON.stringify(item) : String(item)
        ).join(', ') : fallback;
      } else {
        // Handle objects - try to get name property first, then stringify
        if (value.name) return String(value.name);
        if (value.Name) return String(value.Name);
        return JSON.stringify(value);
      }
    }
    
    // Handle primitive values
    return String(value);
  };

  // Handle opening choice modal for create
  const openCreateModal = () => {
    setChoiceModalMode('create');
    initializeForm();
    setShowChoiceModal(true);
  };

  // Handle opening choice modal for edit
  const openEditModal = (choice) => {
    setChoiceModalMode('edit');
    setEditingChoice(choice);
    
    // Populate form data with existing data using same structure as create form
    const editFormData = {
      contactType: choice.contactType,
      guest: choice.guest ? {
        value: choice.guest._id,
        label: choice.guest.guestName,
        guestName: choice.guest.guestName,
        phoneNo: choice.guest.phoneNo,
        ...choice.guest
      } : null,
      reference: choice.reference ? {
        value: choice.reference._id,
        label: choice.reference.name,
        name: choice.reference.name,
        phoneNumber: choice.reference.phoneNumber,
        type: choice.reference.type,
        ...choice.reference
      } : null,
      customer: choice.customer ? {
        value: choice.customer._id,
        label: choice.customer.name,
        name: choice.customer.name,
        customerCode: choice.customer.customerCode,
        phone: choice.customer.phone,
        email: choice.customer.email,
        ...choice.customer
      } : null,
      dealer: choice.dealer ? {
        value: choice.dealer._id,
        label: choice.dealer.businessName,
        businessName: choice.dealer.businessName,
        businessOwner: choice.dealer.businessOwner,
        phone: choice.dealer.phone,
        email: choice.dealer.email,
        address: choice.dealer.address,
      } : null,
      paymentRemark: choice.paymentRemark || '',
      items: choice.items.map(item => ({
        tallyItem: item.tallyItem ? {
          value: item.tallyItem._id || item.tallyItem.name || Math.random().toString(),
          label: item.tallyItem.Name || item.tallyItem.name,
          Name: item.tallyItem.Name || item.tallyItem.name,
          ...item.tallyItem
        } : null,
        quantity: item.quantity || 1,
        uom: item.uom || 'pcs',
        price: item.price || 0,
        pricePerSqft: parseFloat(item.pricePerSqft).toFixed(2) || 0,
        amount: item.amount || 0, // Will be recalculated below
        applicationArea: item.applicationArea || '',
        markup: item.markup || '',
        remarks: item.remarks || '',
        availability: item.availability || '',
        calculationType: item.calculationType || 'pcs',
        areaValue: item.areaValue || 0,
        areaUnit: item.areaUnit || 'sqft',
        boxQuantity: item.boxQuantity || 0,
        pcsQuantity: item.pcsQuantity || 0
      }))
    };
    
    // Recalculate amounts properly for all items
    editFormData.items = recalculateAmounts(editFormData.items);
    
    setFormData(editFormData);
    setShowChoiceModal(true);
  };

  // Handle form submission for both create and edit
  const handleChoiceSubmit = async (e) => {
    e.preventDefault();
    
    // Debug logging
    console.log('Form submission started');
    console.log('Form data:', formData);
    console.log('User:', user);
    
    // Validate contact selection
    if (formData.contactType === 'Guest' && !formData.guest) {
      Swal.fire('Error', 'Please select a guest', 'error');
      return;
    }
    
    if (formData.contactType === 'Reference' && !formData.reference) {
      Swal.fire('Error', 'Please select a reference', 'error');
      return;
    }
    
    if (formData.contactType === 'Customer' && !formData.customer) {
      Swal.fire('Error', 'Please select a customer', 'error');
      return;
    }
    
    if (formData.contactType === 'Dealer' && !formData.dealer) {
      Swal.fire('Error', 'Please select a dealer', 'error');
      return;
    }
    
    // Validate items array
    const validItems = formData.items.filter(item => item.tallyItem);
    if (validItems.length === 0) {
      Swal.fire('Error', 'Please add at least one item', 'error');
      return;
    }

    // Validate createdBy
    if (!user?.user?._id) {
      Swal.fire('Error', 'User information not found. Please refresh and try again.', 'error');
      return;
    }

    // Enhanced zero validation for items
    const invalidItems = [];
    formData.items.forEach((item, index) => {
      if (item.tallyItem) {
        if (item.quantity <= 0) {
          invalidItems.push(`Item ${index + 1}: Quantity must be greater than 0`);
        }
        if (item.price <= 0) {
          invalidItems.push(`Item ${index + 1}: Price must be greater than 0`);
        }
      }
    });

    // Show validation errors if any
    if (invalidItems.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        html: invalidItems.join('<br>'),
        confirmButtonText: 'OK'
      });
      return;
    }

    try {
      const requestData = {
        contactType: formData.contactType,
        guest: formData.contactType === 'Guest' ? (formData.guest?.value || formData.guest?._id) : null,
        reference: formData.contactType === 'Reference' ? (formData.reference?.value || formData.reference?._id) : null,
        customer: formData.contactType === 'Customer' ? (formData.customer?.value || formData.customer?._id) : null,
        dealer: formData.contactType === 'Dealer' ? (formData.dealer?.value || formData.dealer?._id) : null,
        paymentRemark: formData.paymentRemark,
        items: formData.items.filter(item => item.tallyItem).map(item => ({
          tallyItem: item.tallyItem,
          quantity: item.quantity,
          uom: item.uom,
          price: item.price,
          pricePerSqft: item.pricePerSqft,
          amount: item.amount,
          applicationArea: item.applicationArea,
          markup: item.markup,
          remarks: item.remarks,
          availability: item.availability,
          calculationType: item.calculationType,
          areaValue: item.areaValue,
          areaUnit: item.areaUnit,
          boxQuantity: item.boxQuantity,
          pcsQuantity: item.pcsQuantity
        })),
        createdBy: user.user._id,
        updatedBy: user.user._id
      };

      // Debug logging
      console.log('Submitting choice data:', requestData);
      console.log('Form data:', formData);
      console.log('User info:', user.user);

      let response;
      if (choiceModalMode === 'create') {
        response = await axios.post(`${API_BASE}/choices`, requestData, {
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'Content-Type': 'application/json'
          }
        });
      } else {
        response = await axios.put(`${API_BASE}/choices/${editingChoice._id}`, requestData, {
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'Content-Type': 'application/json'
          }
        });
      }

      if (response.data.success) {
        Swal.fire('Success', 
          choiceModalMode === 'create' ? 'Choice created successfully' : 'Choice updated successfully', 
          'success'
        );
        setShowChoiceModal(false);
        setEditingChoice(null);
        initializeForm();
        loadChoices(); // Refresh the choices list
        loadAnalytics(); // Refresh analytics
      } else {
        Swal.fire('Error', response.data.message || `Failed to ${choiceModalMode} choice`, 'error');
      }
    } catch (error) {
      console.error(`Error ${choiceModalMode === 'create' ? 'creating' : 'updating'} choice:`, error);
      
      // Show specific error message from server if available
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          `Failed to ${choiceModalMode} choice`;
      
      Swal.fire('Error', errorMessage, 'error');
    }
  };

  // Handle back navigation with confirmation
  const handleChoiceBackNavigation = () => {
    const hasChanges = choiceModalMode === 'create' ? (
      formData.contactType !== 'Guest' ||
      formData.guest !== null ||
      formData.reference !== null ||
      formData.items.some(item => item.tallyItem || item.quantity !== 1 || item.price !== 0)
    ) : (
      // For edit mode, check if form has been modified from original
      JSON.stringify(formData) !== JSON.stringify({
        contactType: editingChoice?.guest ? 'Guest' : 'Reference',
        guest: editingChoice?.guest ? {
          value: editingChoice.guest._id,
          label: editingChoice.guest.guestName,
          guestName: editingChoice.guest.guestName,
          phoneNo: editingChoice.guest.phoneNo,
          ...editingChoice.guest
        } : null,
        reference: editingChoice?.reference ? {
          value: editingChoice.reference._id,
          label: editingChoice.reference.name,
          name: editingChoice.reference.name,
          phoneNumber: editingChoice.reference.phoneNumber,
          type: editingChoice.reference.type,
          ...editingChoice.reference
        } : null,
        paymentRemark: editingChoice?.paymentRemark || '',
        items: editingChoice?.items.map(item => ({
          tallyItem: item.tallyItem ? {
            value: item.tallyItem._id || item.tallyItem.name || Math.random().toString(),
            label: item.tallyItem.Name || item.tallyItem.name,
            Name: item.tallyItem.Name || item.tallyItem.name,
            ...item.tallyItem
          } : null,
          quantity: item.quantity || 1,
          uom: item.uom || 'pcs',
          price: item.price || 0,
          amount: item.amount || (item.quantity * item.price) || 0,
          applicationArea: item.applicationArea || '',
          markup: item.markup || '',
          remarks: item.remarks || '',
          availability: item.availability || '',
          calculationType: item.calculationType || 'pcs',
          areaValue: item.areaValue || 0,
          areaUnit: item.areaUnit || 'sqft',
          boxQuantity: item.boxQuantity || 0,
          pcsQuantity: item.pcsQuantity || 0
        })) || []
      })
    );

    if (hasChanges) {
      Swal.fire({
        title: 'Unsaved Changes',
        text: 'You have unsaved changes. Are you sure you want to leave?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, leave',
        cancelButtonText: 'Stay'
      }).then((result) => {
        if (result.isConfirmed) {
          initializeForm();
          setShowChoiceModal(false);
          setEditingChoice(null);
        }
      });
    } else {
      initializeForm();
      setShowChoiceModal(false);
      setEditingChoice(null);
    }
  };

  // Helper functions for edit form
  const handleCreateGuest = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!newGuestForm.guestName || !newGuestForm.phoneNo || !newGuestForm.station || !newGuestForm.reference || !newGuestForm.salesperson) {
      Swal.fire('Error', 'Please fill all required fields', 'error');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE}/guests`, {
        guestName: newGuestForm.guestName,
        phoneNo: newGuestForm.phoneNo,
        secondaryPhoneNo: newGuestForm.secondaryPhoneNo,
        email: newGuestForm.email,
        station: newGuestForm.station?.value || newGuestForm.station,
        reference: newGuestForm.reference,
        salesperson: newGuestForm.salesperson?.value || newGuestForm.salesperson,
        createdBy: user.user._id
      }, {
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });

      if (response.data.success) {
        // Select the newly created guest
        setFormData(prev => ({ ...prev, guest: response.data.data }));
        
        // Reset form and close modal
        setNewGuestForm({
          guestName: '',
          phoneNo: '',
          secondaryPhoneNo: '',
          email: '',
          station: null,
          reference: '',
          salesperson: null
        });
        setShowCreateGuestModal(false);
        
        // Refresh guest list
        loadGuests(1, guestSearch);
        
        Swal.fire('Success', 'Guest created successfully', 'success');
      }
    } catch (error) {
      console.error('Error creating guest:', error);
      Swal.fire('Error', error.response?.data?.error || 'Failed to create guest', 'error');
    }
  };

  // Handle creating new reference
  const handleCreateReference = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!newReferenceForm.name || !newReferenceForm.phoneNumber || !newReferenceForm.classification || !newReferenceForm.type || !newReferenceForm.station) {
      Swal.fire('Error', 'Please fill all required fields', 'error');
      return;
    }

    try {
      const response = await axios.post(`${API_BASE}/references`, {
        ...newReferenceForm,
        createdBy: user.user._id
      }, {
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });

      if (response.status === 201) {
        // Select the newly created reference
        setFormData(prev => ({ ...prev, reference: response.data }));
        
        // Reset form and close modal
        setNewReferenceForm({
          name: '',
          phoneNumber: '',
          secondaryPhoneNumber: '',
          classification: '',
          type: '',
          station: ''
        });
        setShowCreateReferenceModal(false);
        
        // Refresh reference list
        loadReferences(1, referenceSearch);
        
        Swal.fire('Success', 'Reference created successfully', 'success');
      }
    } catch (error) {
      console.error('Error creating reference:', error);
      Swal.fire('Error', error.response?.data?.error || 'Failed to create reference', 'error');
    }
  };

  // === Customer GST/PAN Verification Handlers ===
  const handleCustomerGSTVerificationData = ({ gstData, gstin, useData }) => {
    if (useData && gstData) {
      const extractedData = gstData.extractedData || {};
      const extractedPAN = gstin.substring(2, 12);
      
      setNewCustomerForm(prev => ({
        ...prev,
        gstNo: gstin,
        panNo: extractedPAN,
        name: extractedData.legalName || extractedData.tradeName || prev.name,
        siteAddress: extractedData.address || prev.siteAddress,
        deliveryAddress: !prev.deliveryAddress ? extractedData.address : prev.deliveryAddress
      }));
      
      setIsCustomerPanReadOnly(true);
      setIsCustomerGstReadOnly(true);
      setShowCustomerGstPanFields(true);
      
      const populatedFields = [];
      if (extractedData.legalName || extractedData.tradeName) populatedFields.push('Name');
      if (extractedPAN) populatedFields.push('PAN');
      if (extractedData.address) populatedFields.push('Address');
      
      Swal.fire({
        title: 'GST Verified Successfully!',
        html: `
          <div class="text-left">
            <p class="mb-2"><strong>GSTIN:</strong> ${gstin}</p>
            <p class="mb-2"><strong>Extracted PAN:</strong> ${extractedPAN}</p>
            <p class="mb-2"><strong>Status:</strong> ${gstData.sts || 'N/A'}</p>
            ${populatedFields.length > 0 ? `<p class="mt-3 text-sm text-green-600"><strong>Auto-filled:</strong> ${populatedFields.join(', ')}</p>` : ''}
            <p class="mt-3 text-sm text-blue-600">ℹ️ PAN has been automatically extracted from GSTIN.</p>
          </div>
        `,
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3b82f6'
      });
    }
  };

  const handleCustomerPANVerificationData = ({ panNo, verificationData }) => {
    setNewCustomerForm(prev => ({ ...prev, panNo }));
    setIsCustomerPanReadOnly(true);
    setShowCustomerGstPanFields(true);
    
    const gstinList = verificationData.gstinResList || [];
    
    if (gstinList.length > 0) {
      const gstinOptions = gstinList.map(item => 
        `<option value="${item.gstin}">${item.gstin} (${item.authStatus || 'N/A'} - State: ${item.stateCd || 'N/A'})</option>`
      ).join('');
      
      Swal.fire({
        icon: 'success',
        title: 'PAN Verified Successfully!',
        html: `
          <div class="text-left">
            <p class="mb-3"><strong>PAN:</strong> ${panNo}</p>
            <p class="mb-2 font-semibold">This PAN has ${gstinList.length} linked GSTIN(s):</p>
            <select id="gstin-select" class="w-full border border-gray-300 rounded-md p-2 mb-3">
              <option value="">-- Select a GSTIN --</option>
              ${gstinOptions}
            </select>
            <p class="text-sm text-blue-600">💡 Select a GSTIN to auto-fill GST field</p>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Use Selected GSTIN',
        cancelButtonText: 'Skip',
        confirmButtonColor: '#3b82f6',
        cancelButtonColor: '#6b7280',
        preConfirm: () => {
          const selectedGSTIN = document.getElementById('gstin-select').value;
          if (!selectedGSTIN) {
            Swal.showValidationMessage('Please select a GSTIN');
            return false;
          }
          return selectedGSTIN;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          setNewCustomerForm(prev => ({ ...prev, gstNo: result.value }));
          setIsCustomerGstReadOnly(true);
          Swal.fire({ icon: 'success', title: 'GSTIN Set!', timer: 2000, showConfirmButton: false });
        }
      });
    } else {
      Swal.fire({
        icon: 'success',
        title: 'PAN Verified!',
        html: `<p><strong>PAN:</strong> ${panNo}</p><p class="text-sm text-yellow-600 mt-2">⚠️ No linked GSTINs found.</p>`,
        timer: 3000,
        showConfirmButton: false
      });
    }
  };

  // === Dealer GST/PAN Verification Handlers ===
  const handleDealerGSTVerificationData = ({ gstData, gstin, useData }) => {
    if (useData && gstData) {
      const extractedData = gstData.extractedData || {};
      const extractedPAN = gstin.substring(2, 12);
      
      setNewDealerForm(prev => ({
        ...prev,
        gstNo: gstin,
        panNo: extractedPAN,
        businessName: extractedData.tradeName || prev.businessName,
        businessOwner: !prev.businessOwner ? extractedData.legalName : prev.businessOwner,
        address: extractedData.address || prev.address
      }));
      
      setIsDealerPanReadOnly(true);
      setIsDealerGstReadOnly(true);
      setShowDealerGstPanFields(true);
      
      const populatedFields = [];
      if (extractedData.tradeName) populatedFields.push('Business Name');
      if (extractedData.legalName) populatedFields.push('Business Owner');
      if (extractedPAN) populatedFields.push('PAN');
      if (extractedData.address) populatedFields.push('Address');
      
      Swal.fire({
        title: 'GST Verified Successfully!',
        html: `
          <div class="text-left">
            <p class="mb-2"><strong>GSTIN:</strong> ${gstin}</p>
            <p class="mb-2"><strong>Extracted PAN:</strong> ${extractedPAN}</p>
            <p class="mb-2"><strong>Business Type:</strong> ${gstData.ctb || 'N/A'}</p>
            <p class="mb-2"><strong>Status:</strong> ${gstData.sts || 'N/A'}</p>
            ${populatedFields.length > 0 ? `<p class="mt-3 text-sm text-green-600"><strong>Auto-filled:</strong> ${populatedFields.join(', ')}</p>` : ''}
            <p class="mt-3 text-sm text-blue-600">ℹ️ PAN has been automatically extracted from GSTIN.</p>
          </div>
        `,
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3b82f6'
      });
    }
  };

  const handleDealerPANVerificationData = ({ panNo, verificationData }) => {
    setNewDealerForm(prev => ({ ...prev, panNo }));
    setIsDealerPanReadOnly(true);
    setShowDealerGstPanFields(true);
    
    const gstinList = verificationData.gstinResList || [];
    
    if (gstinList.length > 0) {
      const gstinOptions = gstinList.map(item => 
        `<option value="${item.gstin}">${item.gstin} (${item.authStatus || 'N/A'} - State: ${item.stateCd || 'N/A'})</option>`
      ).join('');
      
      Swal.fire({
        icon: 'success',
        title: 'PAN Verified Successfully!',
        html: `
          <div class="text-left">
            <p class="mb-3"><strong>PAN:</strong> ${panNo}</p>
            <p class="mb-2 font-semibold">This PAN has ${gstinList.length} linked GSTIN(s):</p>
            <select id="gstin-select" class="w-full border border-gray-300 rounded-md p-2 mb-3">
              <option value="">-- Select a GSTIN --</option>
              ${gstinOptions}
            </select>
            <p class="text-sm text-blue-600">💡 Select a GSTIN to auto-fill GST field</p>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Use Selected GSTIN',
        cancelButtonText: 'Skip',
        confirmButtonColor: '#3b82f6',
        cancelButtonColor: '#6b7280',
        preConfirm: () => {
          const selectedGSTIN = document.getElementById('gstin-select').value;
          if (!selectedGSTIN) {
            Swal.showValidationMessage('Please select a GSTIN');
            return false;
          }
          return selectedGSTIN;
        }
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          setNewDealerForm(prev => ({ ...prev, gstNo: result.value }));
          setIsDealerGstReadOnly(true);
          Swal.fire({ icon: 'success', title: 'GSTIN Set!', timer: 2000, showConfirmButton: false });
        }
      });
    } else {
      Swal.fire({
        icon: 'success',
        title: 'PAN Verified!',
        html: `<p><strong>PAN:</strong> ${panNo}</p><p class="text-sm text-yellow-600 mt-2">⚠️ No linked GSTINs found.</p>`,
        timer: 3000,
        showConfirmButton: false
      });
    }
  };

  // === Create Customer Handler ===
  const handleCreateCustomer = async (e) => {
    e.preventDefault();
    
    if (!newCustomerForm.name || !newCustomerForm.phone) {
      Swal.fire('Error', 'Name and Phone are required', 'error');
      return;
    }

    if (isCreatingCustomer) return;
    setIsCreatingCustomer(true);

    try {
      Swal.fire({
        title: 'Creating Customer...',
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false,
        showConfirmButton: false
      });

      const response = await axios.post(`${API_BASE}/customers`, {
        ...newCustomerForm,
        createdBy: user.user._id
      }, {
        headers: { 'Authorization': `Bearer ${user.token}` }
      });

      if (response.data) {
        // Select the newly created customer
        const created = response.data.customer || response.data;
        setFormData(prev => ({ ...prev, customer: created }));
        
        // Reset form and close modal
        setNewCustomerForm({
          name: '', phone: '', secondaryPhone: '', email: '',
          station: '', pinCode: '', panNo: '', gstNo: '',
          siteAddress: '', deliveryAddress: '', salutation: '',
          createdBy: user?.user?._id
        });
        setIsCustomerPanReadOnly(false);
        setIsCustomerGstReadOnly(false);
        setShowCustomerGstPanFields(false);
        setShowCreateCustomerModal(false);
        setShowCustomerModal(false);
        
        loadCustomers(1, customerSearch);
        Swal.fire('Success', 'Customer created successfully', 'success');
      }
    } catch (error) {
      console.error('Error creating customer:', error);
      Swal.fire('Error', error.response?.data?.error || 'Failed to create customer', 'error');
    } finally {
      setIsCreatingCustomer(false);
    }
  };

  // === Create Dealer Handler ===
  const handleCreateDealer = async (e) => {
    e.preventDefault();
    
    if (!newDealerForm.phone) {
      Swal.fire('Error', 'Phone is required', 'error');
      return;
    }

    if (isCreatingDealer) return;
    setIsCreatingDealer(true);

    try {
      Swal.fire({
        title: 'Creating Dealer...',
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false,
        showConfirmButton: false
      });

      const response = await axios.post(`${API_BASE}/dealers`, {
        ...newDealerForm,
        createdBy: user.user._id
      }, {
        headers: { 'Authorization': `Bearer ${user.token}` }
      });

      if (response.data) {
        const created = response.data.dealer || response.data;
        setFormData(prev => ({ ...prev, dealer: created }));
        
        setNewDealerForm({
          businessName: '', businessOwner: '', phone: '', secondaryPhone: '',
          email: '', address: '', station: '', pinCode: '',
          gstNo: '', panNo: '', createdBy: user?.user?._id
        });
        setIsDealerPanReadOnly(false);
        setIsDealerGstReadOnly(false);
        setShowDealerGstPanFields(false);
        setShowCreateDealerModal(false);
        setShowDealerModal(false);
        
        loadDealers(1, dealerSearch);
        Swal.fire('Success', 'Dealer created successfully', 'success');
      }
    } catch (error) {
      console.error('Error creating dealer:', error);
      Swal.fire('Error', error.response?.data?.error || 'Failed to create dealer', 'error');
    } finally {
      setIsCreatingDealer(false);
    }
  };

  // Function to calculate form completion percentage for edit form
  // Function to calculate form completion percentage
  const getFormCompletionPercentage = () => {
    let total = 0;
    let completed = 0;
    
    // Contact selection (25%)
    total += 25;
    if (formData.contactType === 'Guest' && formData.guest) completed += 25;
    if (formData.contactType === 'Reference' && formData.reference) completed += 25;
    if (formData.contactType === 'Customer' && formData.customer) completed += 25;
    if (formData.contactType === 'Dealer' && formData.dealer) completed += 25;
    
    // Items selection (75%)
    const itemsWeight = 75;
    const itemsTotal = formData.items.length;
    if (itemsTotal > 0) {
      const itemsCompleted = formData.items.filter(item => 
        item.tallyItem && item.quantity > 0 && item.price > 0
      ).length;
      completed += Math.floor((itemsCompleted / itemsTotal) * itemsWeight);
    }
    
    return Math.min(completed, 100);
  };

  // Function to handle back navigation with confirmation
  const handleBackNavigation = () => {
    const hasUnsavedChanges = 
      formData.contactType !== 'Guest' ||
      formData.guest !== null ||
      formData.reference !== null ||
      formData.items.some(item => item.tallyItem !== null || item.quantity !== 1 || item.price !== 0);

    if (hasUnsavedChanges) {
      Swal.fire({
        title: 'Unsaved Changes',
        text: 'You have unsaved changes. Are you sure you want to go back?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        cancelButtonColor: '#6b7280',
        confirmButtonText: 'Yes, Go Back',
        cancelButtonText: 'Continue Editing'
      }).then((result) => {
        if (result.isConfirmed) {
          setShowChoiceModal(false);
          setChoiceModalMode('create');
          initializeForm();
        }
      });
    } else {
      setShowChoiceModal(false);
      setChoiceModalMode('create');
      initializeForm();
    }
  };

  // UOM options
  const UOM_OPTIONS = [
    'PCS', 'BOX', 'BAG', 'PKT', 'PAIR', 'ROLL', 'SET', 'BKT', 'MTR', 'SH', 'CAN', 'KG', 'LTR', 'BUNDLES', 'BOTTLE', 'DRUMS', 'SQ.FT', 'SQ.MTR', 'FTS', 'NOS', 'RFT'
  ];

  // Load stations for dropdown
  const [stations, setStations] = useState([]);
  const [salespersons, setSalespersons] = useState([]);
  const [loadingStations, setLoadingStations] = useState(false);
  const [loadingSalespersons, setLoadingSalespersons] = useState(false);

  // Computed options for react-select components
  const stationOptions = stations.map(station => ({
    value: station._id,
    label: station.name
  }));

  const loadStations = async () => {
    setLoadingStations(true);
    try {
      const response = await axios.get(`${API_BASE}/stations`, {
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      setStations(response.data.data || response.data || []);
    } catch (error) {
      console.error('Error loading stations:', error);
      setStations([]);
    } finally {
      setLoadingStations(false);
    }
  };

  const loadSalespersons = async () => {
    setLoadingSalespersons(true);
    try {
      const response = await axios.get(`${API_BASE}/guests/salespersons/list`, {
        params: {
          companyId: user.user.company._id || user.user.company
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      setSalespersons(response.data.data || []);
    } catch (error) {
      console.error('Error loading salespersons:', error);
      setSalespersons([]);
    } finally {
      setLoadingSalespersons(false);
    }
  };

  // Load choices data
  const loadChoices = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        limit: itemsPerPage,
        search: searchTerm,
        sortBy,
        sortOrder,
        companyId: user.user.company._id || user.user.company
      };

      if (dateRange.from) params.dateFrom = dateRange.from.toISOString();
      if (dateRange.to) params.dateTo = dateRange.to.toISOString();
      if (statusFilter) params.status = statusFilter;

      const response = await axios.get(`${API_BASE}/choices`, { 
        params,
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      setChoices(response.data.data || []);
      setTotalPages(response.data.pagination?.totalPages || 1);
      setTotalChoices(response.data.pagination?.totalCount || 0);
      
    } catch (error) {
      console.error('Error loading choices:', error);
      Swal.fire('Error', 'Failed to load choices', 'error');
    } finally {
      setLoading(false);
    }
  };

  // Load analytics data
  const loadAnalytics = async () => {
    setAnalyticsLoading(true);
    try {
      const response = await axios.get(`${API_BASE}/choices/analytics`, {
        params: {
          companyId: user.user.company._id || user.user.company
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      setAnalytics({
        mostCommonItems: response.data.data.mostCommonItems || [],
        totalChoices: response.data.data.totalChoices || 0,
        totalItems: response.data.data.totalItems || 0,
        averageItemsPerChoice: response.data.data.averageItemsPerChoice || 0
      });
      
    } catch (error) {
      console.error('Error loading analytics:', error);
      setAnalytics({
        mostCommonItems: [],
        totalChoices: 0,
        totalItems: 0,
        averageItemsPerChoice: 0
      });
    } finally {
      setAnalyticsLoading(false);
    }
  };

  // Load guests for modal
  const loadGuests = async (page = 1, search = '') => {
    setLoadingGuests(true);
    try {
      const response = await axios.get(`${API_BASE}/guests`, {
        params: {
          page,
          limit: 10,
          search,
          userCompanyId: user.user.company._id || user.user.company
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      if (page === 1) {
        setGuests(response.data.data || []);
      } else {
        setGuests(prev => [...prev, ...(response.data.data || [])]);
      }
      
      setTotalGuestPages(response.data.pagination?.totalPages || 1);
    } catch (error) {
      console.error('Error loading guests:', error);
    } finally {
      setLoadingGuests(false);
    }
  };

  // Load customers for modal
  const loadCustomers = async (page = 1, search = '') => {
    setLoadingCustomers(true);
    try {
      const response = await axios.get(`${API_BASE}/customers`, {
        params: {
          page,
          limit: 10,
          filter: search,
          userCompanyId: user.user.company._id || user.user.company
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      if (page === 1) {
        setCustomers(response.data.customers || []);
      } else {
        setCustomers(prev => [...prev, ...(response.data.customers || [])]);
      }
      
      setTotalCustomerPages(response.data.totalPages || 1);
    } catch (error) {
      console.error('Error loading customers:', error);
    } finally {
      setLoadingCustomers(false);
    }
  };

  // Load dealers for modal
  const loadDealers = async (page = 1, search = '') => {
    setLoadingDealers(true);
    try {
      const response = await axios.get(`${API_BASE}/dealers`, {
        params: {
          page,
          limit: 10,
          filter: search,
          userCompanyId: user.user.company._id || user.user.company
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      if (page === 1) {
        setDealers(response.data.dealers || []);
      } else {
        setDealers(prev => [...prev, ...(response.data.dealers || [])]);
      }
      
      // Calculate total pages from totalDealers since backend doesn't return pagination object
      const totalDealers = response.data.totalDealers || 0;
      setTotalDealerPages(Math.ceil(totalDealers / 10));
    } catch (error) {
      console.error('Error loading dealers:', error);
    } finally {
      setLoadingDealers(false);
    }
  };

  // Load references for modal
  const loadReferences = async (page = 1, search = '') => {
    setLoadingReferences(true);
    try {
      const response = await axios.get(`${API_BASE}/choices/references/list`, {
        params: {
          page,
          limit: 10,
          search,
          userCompanyId: user.user.company._id || user.user.company
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      if (page === 1) {
        setReferences(response.data.data || []);
      } else {
        setReferences(prev => [...prev, ...(response.data.data || [])]);
      }
      
      setTotalReferencePages(response.data.pagination?.totalPages || 1);
    } catch (error) {
      console.error('Error loading references:', error);
    } finally {
      setLoadingReferences(false);
    }
  };

  // Load tally items for modal
  const loadTallyItems = async (page = 1, search = '') => {
    setLoadingItems(true);
    try {
      console.log('Loading tally items with user:', user?.user);
      
      const response = await axios.get(`${API_BASE}/tally/items`, {
        params: {
          page,
          limit: 10,
          search,
          company: (user?.user?.company?._id || user?.user?.company) // Use same pattern as TallyItemsManagement
        },
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      console.log('Tally items API call params:', {
        page,
        limit: 10,
        search,
        company: (user?.user?.company?._id || user?.user?.company)
      });
      console.log('Tally items response:', response.data); // Debug log
      
      if (page === 1) {
        setTallyItems(response.data.data || []); // Use response.data.data based on backend response structure
      } else {
        setTallyItems(prev => [...prev, ...(response.data.data || [])]);
      }
      
      setTotalItemPages(response.data.pagination?.pages || 1);
    } catch (error) {
      console.error('Error loading tally items:', error);
      console.error('Error response:', error.response?.data);
    } finally {
      setLoadingItems(false);
    }
  };

  // Initialize form
  const initializeForm = () => {
    setFormData({
      contactType: 'Guest',
      guest: null,
      reference: null,
      customer: null,
      dealer: null,
      paymentRemark: '',
      items: [{
        tallyItem: null,
        quantity: 1,
        uom: 'pcs',
        price: 0,
        amount: 0,
        applicationArea: '',
        markup: '',
        remarks: '',
        calculationType: 'pcs',
        areaValue: 0,
        areaUnit: 'sqft',
        boxQuantity: 0,
        pcsQuantity: 0
      }]
    });
  };

  // Handle guest selection
  const handleGuestSelect = (guest) => {
    setFormData(prev => ({ ...prev, guest }));
    setShowGuestModal(false);
  };

  // Handle reference selection
  const handleReferenceSelect = (reference) => {
    setFormData(prev => ({ ...prev, reference }));
    setShowReferenceModal(false);
  };

  // Handle customer selection
  const handleCustomerSelect = (customer) => {
    setFormData(prev => ({ ...prev, customer }));
    setShowCustomerModal(false);
  };

  // Handle dealer selection
  const handleDealerSelect = (dealer) => {
    setFormData(prev => ({ ...prev, dealer }));
    setShowDealerModal(false);
  };

  // Handle item selection
  const handleItemSelect = (item) => {
    // Check for duplicate items
    const isItemAlreadySelected = formData.items.some((existingItem, index) => 
      index !== selectedItemIndex && 
      existingItem.tallyItem && 
      existingItem.tallyItem._id === item._id
    );

    if (isItemAlreadySelected) {
      Swal.fire({
        icon: 'warning',
        title: 'Duplicate Item',
        text: `Item "${item.Name}" is already selected in this form.`,
        timer: 2000,
        showConfirmButton: false
      });
      return;
    }

    const newItems = [...formData.items];
    
    // Determine calculation type based on item parameter
    let calculationType = 'pcs';
    if (item.parameter && item.parameter.calculationType === 'pcsPerBox') {
      calculationType = 'pcsPerBox';
    }
    
    newItems[selectedItemIndex] = {
      ...newItems[selectedItemIndex],
      tallyItem: item,
      calculationType: calculationType,
      // Reset calculation fields when changing item
      areaValue: 0,
      boxQuantity: 0,
      pcsQuantity: 0, // Additional pieces, not pieces per box
      // Set area unit from tally parameter for pcsPerBox type
      areaUnit: (calculationType === 'pcsPerBox' && item.parameter?.coverageAreaUnit) ? item.parameter.coverageAreaUnit : 'sqft'
    };
    
    setFormData(prev => ({ ...prev, items: newItems }));
    setShowItemModal(false);
    
    // Set focus on quantity input for this item
    setTimeout(() => {
      const quantityInput = document.querySelector(`input[data-item-index="${selectedItemIndex}"][data-field="quantity"]`);
      if (quantityInput) {
        quantityInput.focus();
        quantityInput.select();
      }
    }, 100);
    
    // No alert needed for manual selection - the UI update is sufficient feedback
  };

  // Handle viewing item details
  const handleViewItemDetails = (item) => {
    // Add safety check to ensure item is valid
    if (!item || typeof item !== 'object') {
      console.error('Invalid item passed to handleViewItemDetails:', item);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Invalid item data. Cannot display item details.',
        timer: 3000,
        showConfirmButton: false
      });
      return;
    }

    // Log the item structure for debugging
    console.log('Item details data:', item);
    
    setSelectedItemForDetails(item);
    setShowItemDetailsModal(true);
  };

  // Add new item row
  const addItemRow = () => {
    const newItemIndex = formData.items.length; // Index of the new item that will be added
    
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { 
        tallyItem: null, 
        quantity: 1, 
        uom: 'pcs', 
        price: 0,
        pricePerSqft: 0,
        applicationArea: '',
        markup: '',
        remarks: '',
        calculationType: 'pcs',
        areaValue: 0,
        areaUnit: 'sqft',
        boxQuantity: 0,
        pcsQuantity: 0
      }]
    }));

    // Automatically open item selection modal for the new item
    setSelectedItemIndex(newItemIndex);
    setShowItemModal(true);
  };

  // Remove item row
  const removeItemRow = (index) => {
    if (formData.items.length > 1) {
      const newItems = formData.items.filter((_, i) => i !== index);
      setFormData(prev => ({ ...prev, items: newItems }));
    }
  };

  // Function to recalculate amounts for items (used in edit mode)
  const recalculateAmounts = (items) => {
    return items.map(item => {
      if (!item.tallyItem || !item.price) return item;
      
      let quantityForAmount = 0;
      
      if (item.calculationType === 'pcsPerBox' && item.tallyItem?.parameter) {
        // For pcsPerBox, calculate equivalent boxes for pricing: boxes + (additionalPieces / piecesPerBox)
        const boxes = item.boxQuantity || 0;
        const additionalPieces = item.pcsQuantity || 0;
        const piecesPerBox = item.tallyItem.parameter.piecesPerBox || 1;
        
        quantityForAmount = boxes + (additionalPieces / piecesPerBox);
      } else {
        // For regular pcs, use standard quantity
        quantityForAmount = item.quantity || 0;
      }
      
      const price = parseFloat(item.price) || 0;
      const calculatedAmount = parseFloat((quantityForAmount * price).toFixed(2));
      
      return {
        ...item,
        amount: calculatedAmount
      };
    });
  };

  // Update item field
  const updateItemField = (index, field, value) => {
    const newItems = [...formData.items];
    newItems[index] = { ...newItems[index], [field]: value };
    
    // Handle calculation for pcsPerBox type
    if (field === 'calculationType' && value === 'pcsPerBox') {
      // Reset quantity and set default values
      newItems[index].quantity = 0;
      newItems[index].areaValue = 0;
      newItems[index].boxQuantity = 0;
      newItems[index].pcsQuantity = 0;
    } else if (field === 'calculationType' && value === 'pcs') {
      // Reset calculation fields for pcs type
      newItems[index].areaValue = 0;
      newItems[index].boxQuantity = 0;
      newItems[index].pcsQuantity = newItems[index].quantity;
    }
    
    // Handle pcsPerBox calculations
    if (newItems[index].calculationType === 'pcsPerBox' && newItems[index].tallyItem?.parameter) {
      const parameter = newItems[index].tallyItem.parameter;
      const piecesPerBox = parameter.piecesPerBox || 1;
      
      // Auto-set area unit from parameter
      newItems[index].areaUnit = parameter.coverageAreaUnit || 'sqft';
      
      if (field === 'areaValue' && value > 0) {
        // Calculate from area to boxes and pieces
        const totalBoxesNeeded = value / parameter.coverageArea;
        const wholeBoxes = Math.floor(totalBoxesNeeded);
        const fractionalBox = totalBoxesNeeded - wholeBoxes;
        let additionalPieces = Math.round(fractionalBox * piecesPerBox);
        
        // Ensure additional pieces don't exceed piecesPerBox-1
        if (additionalPieces >= piecesPerBox) {
          additionalPieces = piecesPerBox - 1;
        }
        
        newItems[index].boxQuantity = wholeBoxes;
        newItems[index].pcsQuantity = additionalPieces;
        // Total quantity = (boxes * piecesPerBox) + additional pieces
        newItems[index].quantity = (wholeBoxes * piecesPerBox) + additionalPieces;
      } else if (field === 'boxQuantity' && value >= 0) {
        // When box quantity changes, keep additional pieces as is
        // Total quantity = (boxes * piecesPerBox) + additional pieces
        const additionalPieces = newItems[index].pcsQuantity || 0;
        newItems[index].quantity = (value * piecesPerBox) + additionalPieces;
        
        // Calculate total area coverage
        const boxCoverage = value * parameter.coverageArea;
        const pieceCoverage = additionalPieces * (parameter.coverageArea / piecesPerBox);
        newItems[index].areaValue = boxCoverage + pieceCoverage;
      } else if (field === 'pcsQuantity' && value >= 0) {
        // When additional pieces change, ensure they don't exceed piecesPerBox-1
        const maxAdditionalPieces = piecesPerBox - 1;
        let validAdditionalPieces = value;
        let additionalBoxes = 0;
        
        // If additional pieces >= piecesPerBox, convert excess to additional boxes
        if (value >= piecesPerBox) {
          additionalBoxes = Math.floor(value / piecesPerBox);
          validAdditionalPieces = value % piecesPerBox;
        }
        
        const newBoxes = (newItems[index].boxQuantity || 0) + additionalBoxes;
        
        // Update the values
        newItems[index].boxQuantity = newBoxes;
        newItems[index].pcsQuantity = validAdditionalPieces;
        
        // Total quantity = (boxes * piecesPerBox) + additional pieces
        newItems[index].quantity = (newBoxes * piecesPerBox) + validAdditionalPieces;
        
        // Calculate total area coverage
        const boxCoverage = newBoxes * parameter.coverageArea;
        const pieceCoverage = validAdditionalPieces * (parameter.coverageArea / piecesPerBox);
        newItems[index].areaValue = boxCoverage + pieceCoverage;
      }
    }
    
    // Calculate amount for the item
    if (field === 'price' || field === 'quantity' || field === 'boxQuantity' || field === 'pcsQuantity' || field === 'areaValue') {
      let quantityForAmount = 0;
      
      if (newItems[index].calculationType === 'pcsPerBox' && newItems[index].tallyItem?.parameter) {
        // For pcsPerBox, calculate equivalent boxes for pricing: boxes + (additionalPieces / piecesPerBox)
        const boxes = newItems[index].boxQuantity || 0;
        const additionalPieces = newItems[index].pcsQuantity || 0;
        const piecesPerBox = newItems[index].tallyItem.parameter.piecesPerBox || 1;
        
        quantityForAmount = boxes + (additionalPieces / piecesPerBox);
      } else {
        // For regular pcs, use standard quantity
        quantityForAmount = newItems[index].quantity || 0;
      }
      
      const price = parseFloat(newItems[index].price) || 0;
      newItems[index].amount = parseFloat((quantityForAmount * price).toFixed(2));
    }

    // Calculate pricePerSqft for pcsPerBox items when price is updated
    if (field === 'price' && newItems[index].calculationType === 'pcsPerBox' && newItems[index].tallyItem?.parameter) {
      const parameter = newItems[index].tallyItem.parameter;
      const coverageArea = parameter.coverageArea || 1;
      const boxPrice = parseFloat(value) || 0;
      
      // Calculate price per sqft: box price / coverage area
      newItems[index].pricePerSqft = parseFloat((boxPrice / coverageArea).toFixed(2));
    }

    // Calculate box price from pricePerSqft for pcsPerBox items when pricePerSqft is updated
    if (field === 'pricePerSqft' && newItems[index].calculationType === 'pcsPerBox' && newItems[index].tallyItem?.parameter) {
      const parameter = newItems[index].tallyItem.parameter;
      const coverageArea = parameter.coverageArea || 1;
      const pricePerSqft = parseFloat(value) || 0;
      
      // Calculate box price: pricePerSqft * coverage area
      newItems[index].price = parseFloat((pricePerSqft * coverageArea).toFixed(2));
      
      // Recalculate amount with new price
      let quantityForAmount = 0;
      const boxes = newItems[index].boxQuantity || 0;
      const additionalPieces = newItems[index].pcsQuantity || 0;
      const piecesPerBox = parameter.piecesPerBox || 1;
      
      quantityForAmount = boxes + (additionalPieces / piecesPerBox);
      newItems[index].amount = parseFloat((quantityForAmount * newItems[index].price).toFixed(2));
    }
    
    setFormData(prev => ({ ...prev, items: newItems }));
  };

  // Validation helper function
  const validateItemField = (item, field) => {
    if (!item.tallyItem) return true; // Skip validation for empty items
    
    switch (field) {
      case 'quantity':
        return item.calculationType === 'pcsPerBox' || (item.quantity && item.quantity > 0);
      
      case 'price':
        return item.price && item.price > 0;
      
      case 'boxAndPieces':
        if (item.calculationType === 'pcsPerBox') {
          const boxQty = item.boxQuantity || 0;
          const pcsQty = item.pcsQuantity || 0;
          return boxQty > 0 || pcsQty > 0;
        }
        return true;
      
      case 'areaValue':
        if (item.tallyItem?.parameter?.heightRequired || item.tallyItem?.parameter?.widthRequired) {
          return item.areaValue && item.areaValue > 0;
        }
        return true;
      
      default:
        return true;
    }
  };

  // Get validation error message
  const getValidationMessage = (item, field) => {
    if (!item.tallyItem || validateItemField(item, field)) return '';
    
    switch (field) {
      case 'quantity':
        return 'Quantity must be greater than 0';
      case 'price':
        return 'Price must be greater than 0';
      case 'boxAndPieces':
        return 'Must have at least 1 box or 1 piece';
      case 'areaValue':
        return 'Area value is required';
      default:
        return '';
    }
  };

  // Calculate boxes and pieces based on area
  const calculateBoxesAndPieces = (item) => {
    if (item.tallyItem && item.tallyItem.parameter && 
        item.tallyItem.parameter.calculationType === 'pcsPerBox' &&
        item.tallyItem.parameter.coverageArea && 
        item.tallyItem.parameter.piecesPerBox && 
        item.areaValue > 0) {
      
      const parameter = item.tallyItem.parameter;
      
      // Calculate total pieces needed for the area
      const totalPiecesNeeded = Math.ceil(item.areaValue / parameter.coverageArea * parameter.piecesPerBox);
      
      // Calculate boxes and additional pieces
      const boxesNeeded = Math.floor(totalPiecesNeeded / parameter.piecesPerBox);
      const additionalPieces = totalPiecesNeeded % parameter.piecesPerBox;
      
      // Update the item quantities
      item.boxQuantity = boxesNeeded;
      item.pcsQuantity = additionalPieces; // Only additional pieces, not total pieces
      item.quantity = totalPiecesNeeded; // Set main quantity for compatibility
    } else {
      item.boxQuantity = 0;
      item.pcsQuantity = 0;
    }
  };

  // Reset filters
  const resetFilters = () => {
    setSearchTerm('');
    setDateRange({ from: null, to: null });
    setSortBy('createdAt');
    setSortOrder('desc');
    setStatusFilter('');
    setCurrentPage(1);
  };

  // Handle status update
  const handleStatusUpdate = async () => {
    if (!selectedChoice || !newStatus) {
      Swal.fire('Error', 'Please select a status', 'error');
      return;
    }

    try {
      const response = await axios.patch(
        `${API_BASE}/choices/${selectedChoice._id}/status`,
        {
          status: newStatus,
          updatedBy: user.user._id
        },
        {
          headers: {
            'Authorization': `Bearer ${user.token}`
          }
        }
      );

      if (response.data.success) {
        Swal.fire('Success', 'Choice status updated successfully', 'success');
        setShowStatusModal(false);
        setSelectedChoice(null);
        setNewStatus('');
        loadChoices();
        loadAnalytics(); // Reload analytics after status update
      }
    } catch (error) {
      console.error('Error updating choice status:', error);
      Swal.fire('Error', 'Failed to update choice status', 'error');
    }
  };

  // Open status modal
  const openStatusModal = (choice) => {
    setSelectedChoice(choice);
    setNewStatus(choice.status);
    setShowStatusModal(true);
  };

  // Open view modal
  const openViewModal = (choice) => {
    setViewingChoice(choice);
    setShowViewModal(true);
  };

  // Get status color
  const getStatusColor = (status) => {
    switch (status) {
      case 'Pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'Positive':
        return 'bg-green-100 text-green-800';
      case 'Negative':
        return 'bg-red-100 text-red-800';
      case 'Follow-up':
        return 'bg-blue-100 text-blue-800';
      case 'Draft':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  // QR Scanner functions
  const openQRScanner = async () => {
    await getAvailableCameras();
    setShowQRScanner(true);
    // Start scanner after modal is shown
    setTimeout(() => startQRScanner(), 100);
  };

  const startQRScanner = async () => {
    try {
      setQrScannerLoading(true);

      // Get available cameras first if not already loaded
      if (availableCameras.length === 0) {
        await getAvailableCameras();
      }

      // The QRScanner component handles initialization
      setQrScannerLoading(false);
      console.log('QR Scanner ready to start');

    } catch (error) {
      console.error('Error preparing QR scanner:', error);
      setQrScannerLoading(false);
      
      let errorMessage = 'Could not start QR scanner.';
      if (error.message?.includes('Permission denied') || error.name === 'NotAllowedError') {
        errorMessage = 'Camera access was denied. Please allow camera permissions and try again.';
      } else if (error.message?.includes('NotFoundError') || error.name === 'NotFoundError') {
        errorMessage = 'No cameras found on this device.';
      } else if (error.message?.includes('OverconstrainedError') || error.name === 'OverconstrainedError') {
        errorMessage = 'The selected camera is not available. Please try a different camera.';
        // Reset to default camera selection
        if (availableCameras.length > 0) {
          setSelectedCameraId(availableCameras[0].id);
        }
      }
      
      Swal.fire({
        icon: 'error',
        title: 'Camera Error',
        text: errorMessage,
      });
    }
  };

  const handleQRScanSuccess = async (qrCodeData) => {
    if (qrCodeData && !qrScanProcessing) {
      setQrScanProcessing(true); // Prevent multiple scans
      
      try {
        // Assume the QR code contains the item ObjectId
        const itemId = qrCodeData.trim();
        console.log('QR Code scanned:', itemId);
        
        // Basic validation for MongoDB ObjectId format
        if (!/^[0-9a-fA-F]{24}$/.test(itemId)) {
          console.warn('QR code does not contain a valid ObjectId:', itemId);
          throw new Error('Invalid QR code format. Expected a valid item ID.');
        }
        
        // Fetch item details by ID
        const response = await axios.get(`${API_BASE}/tally/items/${itemId}`, {
          headers: {
            'Authorization': `Bearer ${user.token}`
          }
        });
        
        if (response.data.success) {
          const scannedItem = response.data.data;
          console.log('Scanned item data:', scannedItem);
          
          // Check if the scanned item belongs to the user's company
          const userCompanyId = user?.user?.company?._id || user?.user?.company;
          const itemCompanyId = scannedItem.companyID?.toString();
          
          console.log('Company validation:', {
            userCompanyId,
            itemCompanyId,
            match: userCompanyId?.toString() === itemCompanyId
          });
          
          if (userCompanyId && itemCompanyId && userCompanyId.toString() !== itemCompanyId) {
            console.warn('Item does not belong to user company:', {
              itemName: scannedItem.Name,
              itemCompany: itemCompanyId,
              userCompany: userCompanyId
            });
            
            Swal.fire({
              icon: 'error',
              title: 'Item Not Found',
              text: 'Item not found',
              timer: 2000,
              showConfirmButton: false
            });
            return;
          }
          
          // Check for duplicate items - use form data
          const currentItems = formData.items;
          const isItemAlreadySelected = currentItems.some((existingItem, index) => 
            index !== selectedItemIndex && 
            existingItem.tallyItem && 
            existingItem.tallyItem._id === scannedItem._id
          );

          if (isItemAlreadySelected) {
            Swal.fire({
              icon: 'warning',
              title: 'Duplicate Item',
              text: `Item "${scannedItem.Name}" is already selected in this form.`,
              timer: 2000,
              showConfirmButton: false
            });
            return;
          }
          
          // Add the scanned item to the current item slot
          handleItemSelect(scannedItem);
          
          // Stop scanning and close scanner after successful scan
          setShowQRScanner(false);
          setQrScannerLoading(false);
          
          // Set focus on quantity input for this item
          setTimeout(() => {
            const quantityInput = document.querySelector(`input[data-item-index="${selectedItemIndex}"][data-field="quantity"]`);
            if (quantityInput) {
              quantityInput.focus();
              quantityInput.select();
            }
          }, 100);
          
          // Show success message only once
          Swal.fire({
            icon: 'success',
            title: 'QR Code Scanned!',
            text: `Item "${scannedItem.Name}" selected successfully`,
            timer: 1500,
            showConfirmButton: false
          });
        } else {
          console.error('API response not successful:', response.data);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Item not found',
            timer: 2000,
            showConfirmButton: false
          });
        }
      } catch (error) {
        console.error('Error finding scanned item:', error);
        console.error('Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status
        });
        
        let errorMessage = 'Item not found';
        if (error.response?.status === 404) {
          errorMessage = 'Item not found';
        } else if (error.response?.status === 401) {
          errorMessage = 'Authentication failed. Please login again.';
        } else if (error.response?.status >= 500) {
          errorMessage = 'Server error. Please try again later.';
        } else if (error.message?.includes('Invalid QR code format')) {
          errorMessage = 'Invalid QR code format';
        }
        
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: errorMessage,
          timer: 2000,
          showConfirmButton: false
        });
      } finally {
        // Reset the processing flag after a delay to prevent rapid multiple scans
        setTimeout(() => {
          setQrScanProcessing(false);
        }, 2000);
      }
    }
  };

  const handleQRScan = (data) => {
    if (data && !qrScanProcessing) {
      console.log('QR Code detected:', data);
      console.log('QR Code type:', typeof data);
      console.log('QR Code length:', data.length);
      handleQRScanSuccess(data);
    }
  };

  const handleQRError = (error) => {
    console.error('QR Scanner error:', error);
    setQrScannerLoading(false);
  };

  const handleCameraLoad = (isLoading) => {
    setQrScannerLoading(isLoading);
  };

  const stopQRScanner = async () => {
    // The QRScanner component handles cleanup internally
    // when it unmounts. We just need to update our state.
    setShowQRScanner(false);
    setQrScannerLoading(false);
  };

  const closeQRScanner = () => {
    stopQRScanner();
    setQrCodeData('');
  };

  // Update these functions to match TallyItemsManagement

  // Add the camera enumeration function
  const getAvailableCameras = async () => {
    try {
      const cameras = await QrScanner.listCameras(true);
      console.log('Available cameras:', cameras);
      setAvailableCameras(cameras);
      
      // If no camera is selected, default to the first one or prefer rear camera
      if (!selectedCameraId && cameras.length > 0) {
        const rearCamera = cameras.find(camera => 
          camera.label.toLowerCase().includes('back') || 
          camera.label.toLowerCase().includes('rear') ||
          camera.label.toLowerCase().includes('environment')
        );
        setSelectedCameraId(rearCamera ? rearCamera.id : cameras[0].id);
      }
    } catch (error) {
      console.error('Error getting cameras:', error);
      Swal.fire({
        icon: 'error',
        title: 'Camera Error',
        text: 'Could not access camera devices. Please ensure camera permissions are granted.',
      });
    }
  };

  // Effect hooks
  useEffect(() => {
    // Load initial analytics
    loadAnalytics();
  }, []);

  useEffect(() => {
    loadChoices();
  }, [currentPage, searchTerm, dateRange, sortBy, sortOrder, statusFilter]);

  useEffect(() => {
    if (showGuestModal) {
      loadGuests(1, guestSearch);
    }
  }, [showGuestModal, guestSearch]);

  useEffect(() => {
    if (showReferenceModal) {
      loadReferences(1, referenceSearch);
    }
  }, [showReferenceModal, referenceSearch]);

  useEffect(() => {
    if (showCustomerModal) {
      loadCustomers(1, customerSearch);
    }
  }, [showCustomerModal, customerSearch]);

  useEffect(() => {
    if (showDealerModal) {
      loadDealers(1, dealerSearch);
    }
  }, [showDealerModal, dealerSearch]);

  useEffect(() => {
    if (showItemModal) {
      loadTallyItems(1, itemSearch);
    }
  }, [showItemModal, itemSearch]);

  useEffect(() => {
    if (showCreateGuestModal) {
      loadStations();
      loadSalespersons();
    }
  }, [showCreateGuestModal]);

  useEffect(() => {
    if (showCreateReferenceModal) {
      loadStations();
    }
  }, [showCreateReferenceModal]);

  useEffect(() => {
    if (showCreateCustomerModal) {
      loadStations();
    }
  }, [showCreateCustomerModal]);

  useEffect(() => {
    if (showCreateDealerModal) {
      loadStations();
    }
  }, [showCreateDealerModal]);

  // Listen for full-screen changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  // Keyboard shortcut handler for full-screen modal
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (showChoiceModal && event.key === 'Escape') {
        handleChoiceBackNavigation();
      }
    };

    // Add/remove full-screen class to body
    if (showChoiceModal) {
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'auto';
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'auto';
    };
  }, [showChoiceModal, formData]);

  // Cleanup QR scanner on unmount
  useEffect(() => {
    return () => {
      if (qrScannerRef.current) {
        try {
          qrScannerRef.current.stop();
          if (typeof qrScannerRef.current.clear === 'function') {
            qrScannerRef.current.clear();
          } else if (typeof qrScannerRef.current.destroy === 'function') {
            qrScannerRef.current.destroy();
          }
        } catch (error) {
          console.error('Error cleaning up QR scanner:', error);
        }
      }
      stopQRScanner();
    };
  }, []);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Choice Entry</h1>
            <p className="text-gray-600 mt-1">Manage guest choices and item selections</p>
          </div>
          <button
            onClick={() => {
              initializeForm();
              openCreateModal();
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors duration-200"
          >
            <FaPlus className="text-sm" />
            New Choice
          </button>
        </div>

        {/* Analytics Section */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-2">
              <FaChartBar className="text-blue-600 text-lg" />
              <h3 className="text-lg font-semibold text-gray-900">Choice Analytics</h3>
              <button
                onClick={loadAnalytics}
                className="ml-2 p-1 text-gray-400 hover:text-blue-600 transition-colors"
                title="Refresh Analytics"
                disabled={analyticsLoading}
              >
                <FaSync className={`text-sm ${analyticsLoading ? 'animate-spin' : ''}`} />
              </button>
            </div>
            <div className="flex items-center gap-4 text-sm text-gray-600">
              <span>
                Total Items: <span className="font-medium text-blue-600">{analytics.totalItems.toLocaleString()}</span>
              </span>
              <span>
                Avg per Choice: <span className="font-medium text-green-600">{analytics.averageItemsPerChoice}</span>
              </span>
            </div>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {analyticsLoading ? (
              <div className="col-span-2 flex justify-center items-center py-8">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                <span className="ml-2 text-gray-500">Loading analytics...</span>
              </div>
            ) : (
              <>
                {/* Total Choices Summary */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-200">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="text-sm font-medium text-blue-800 mb-1">Total Choices Created</h4>
                      <p className="text-2xl font-bold text-blue-900">{analytics.totalChoices.toLocaleString()}</p>
                      <p className="text-xs text-blue-600 mt-1">
                        Across all guests and items
                      </p>
                    </div>
                    <div className="p-3 bg-blue-200 rounded-full">
                      <FaCheck className="text-blue-800 text-xl" />
                    </div>
                  </div>
                </div>

                {/* Most Common Items */}
                <div>
                  <h4 className="text-sm font-medium text-gray-700 mb-3">Most Common Items</h4>
                  <div className="space-y-2 max-h-48 overflow-y-auto">
                    {analytics.mostCommonItems.length === 0 ? (
                      <div className="text-center py-4 text-gray-500">
                        No items data available
                      </div>
                    ) : (
                      analytics.mostCommonItems.map((item, index) => (
                        <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                          <div className="flex items-center gap-3">
                            <div className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-bold ${
                              index === 0 ? 'bg-yellow-100 text-yellow-800' :
                              index === 1 ? 'bg-gray-100 text-gray-700' :
                              index === 2 ? 'bg-orange-100 text-orange-800' :
                              'bg-blue-50 text-blue-600'
                            }`}>
                              {index + 1}
                            </div>
                            <div className="flex-1">
                              <div className="font-medium text-gray-900 text-sm">{item.name}</div>
                              <div className="text-xs text-gray-500">
                                {item.category} • {item.baseUnits}
                              </div>
                            </div>
                          </div>
                          <div className="text-right">
                            <div className="text-sm font-semibold text-blue-600">{item.count} times</div>
                            <div className="text-xs text-gray-500">{item.totalQuantity} total qty</div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
          {/* Search */}
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search choices..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toUpperCase())}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              style={{ textTransform: 'uppercase' }}
            />
          </div>

          {/* Status Filter */}
          <Select
            onChange={(option) => setStatusFilter(option?.value || '')}
            options={[
            ]}
            placeholder="Filter by status..."
            className="react-select-container"
            classNamePrefix="react-select"
            styles={customSelectStyles}
            isClearable
          />

          {/* Sort Options */}
          <div className="flex gap-2">
            <Select
              onChange={(option) => setSortBy(option.value)}
              options={[
              ]}
              className="react-select-container flex-1"
              classNamePrefix="react-select"
              styles={customSelectStyles}
            />
            <button
              onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
              className="px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
              title={`Sort ${sortOrder === 'asc' ? 'Descending' : 'Ascending'}`}
            >
              {sortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />}
            </button>
          </div>

          {/* Reset Filters */}
          <button
            onClick={resetFilters}
            className="flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200"
          >
            <FaFilter />
            Reset
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Choice ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Guest / Reference / Dealer / Customer
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Items
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Created
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="6" className="px-6 py-12 text-center">
                    <div className="flex justify-center items-center gap-2">
                      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                      <span className="text-gray-500">Loading choices...</span>
                    </div>
                  </td>
                </tr>
              ) : choices.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-6 py-12 text-center text-gray-500">
                    No choices found
                  </td>
                </tr>
              ) : (
                choices.map((choice) => (
                  <tr key={choice._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {choice.id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-8 w-8">
                          <div className={`h-8 w-8 rounded-full flex items-center justify-center ${
                            choice.contactType === 'Reference' ? 'bg-purple-100' : 'bg-blue-100'
                          }`}>
                            <FaUser className={`text-sm ${
                              choice.contactType === 'Reference' ? 'text-purple-600' : 'text-blue-600'
                            }`} />
                          </div>
                        </div>
                        <div className="ml-3">
                          <div className="text-sm font-medium text-gray-900">
                            {choice.contactType === 'Reference' && choice.reference?.name}
                            {choice.contactType === 'Guest' && choice.guest?.guestName}
                            {choice.contactType === 'Customer' && choice.customer?.name}
                            {choice.contactType === 'Dealer' && choice.dealer.businessName}
                          </div>
                          <div className="text-sm text-gray-500">
                            {choice.contactType === 'Reference' 
                              ? choice.reference?.phoneNumber
                              : choice.guest?.phoneNo
                            }
                          </div>
                          {choice.contactType === 'Reference' && choice.reference?.type && (
                            <div className="text-xs text-purple-600 mt-1">
                              {choice.reference.type}
                            </div>
                          )}
                          {choice.contactType === 'Dealer' && (
                            <div className="text-xs text-blue-600 mt-1">
                              {choice.dealer.phone}
                            </div>
                          )}
                          {choice.contactType === 'Customer' && (
                            <div className="text-xs text-green-600 mt-1">
                              {choice.customer.phone}
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {choice.totalItems || choice.items?.length || 0} items
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(choice.status)}`}>
                        {choice.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <div className="flex flex-col">
                        <span>{new Date(choice.createdAt).toLocaleDateString()}</span>
                        {choice.createdBy && (
                          <span className="text-xs text-blue-600 font-medium">
                            by {choice.createdBy.name}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex items-center gap-2">
                        {choice.status === 'Pending' && (
                          <button
                            onClick={() => openEditModal(choice)}
                            className="text-green-600 hover:text-green-900 p-1"
                            title="Edit Choice"
                          >
                            <FaEdit />
                          </button>
                        )}
                        {!(choice.isUpdated) && <button
                          onClick={() => openStatusModal(choice)}
                          className="text-blue-600 hover:text-blue-900 p-1"
                          title="Update Status"
                        >
                          <FaTag />
                        </button>}
                        <button
                          onClick={() => openViewModal(choice)}
                          className="text-gray-600 hover:text-gray-900 p-1"
                          title="View Details"
                        >
                          <FaEye />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-white px-4 py-3 border-t border-gray-200 sm:px-6">
            <div className="flex items-center justify-between">
              <div className="flex-1 flex justify-between sm:hidden">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Previous
                </button>
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
              <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <div>
                  <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{((currentPage - 1) * itemsPerPage) + 1}</span> to{' '}
                    <span className="font-medium">
                      {Math.min(currentPage * itemsPerPage, totalChoices)}
                    </span>{' '}
                    of <span className="font-medium">{totalChoices}</span> results
                  </p>
                </div>
                <div>
                  <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
                    <button
                      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Previous
                    </button>
                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                      const page = i + 1;
                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                            currentPage === page
                              ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                              : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    })}
                    <button
                      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Next
                    </button>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Unified Choice Modal - Full Screen */}
      {showChoiceModal && (
        <div className="fixed inset-0 bg-white z-50 flex flex-col">
          {/* Full Screen Header with Back Button */}
          <div className={`px-6 py-4 shadow-lg ${choiceModalMode === 'create' ? 'bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600' : 'bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600'}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <button
                  onClick={handleChoiceBackNavigation}
                  className="text-white hover:text-blue-200 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-all duration-200 flex items-center gap-2"
                  title="Go Back"
                >
                  <svg 
                    className="w-6 h-6" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M10 19l-7-7m0 0l7-7m-7 7h18" 
                    />
                  </svg>
                  <span className="text-sm font-medium">Back</span>
                </button>
                <div className="text-white">
                  <h2 className="text-2xl font-bold flex items-center gap-3">
                    <div className="p-2 bg-white bg-opacity-20 rounded-lg">
                      {choiceModalMode === 'create' ? <FaShoppingCart size={24} /> : <FaEdit size={24} />}
                    </div>
                    {choiceModalMode === 'create' ? 'Create New Choice' : `Edit Choice - ${editingChoice?.id}`}
                  </h2>
                  <div className="flex items-center gap-4 mt-2">
                    <p className={`${choiceModalMode === 'create' ? 'text-blue-100' : 'text-green-100'}`}>
                      {choiceModalMode === 'create' ? 'Add items and manage customer selections' : 'Update customer selections and items'}
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="flex items-center gap-2 bg-white bg-opacity-20 rounded-lg px-3 py-1">
                        <FaCubes className={`${choiceModalMode === 'create' ? 'text-blue-100' : 'text-green-100'}`} size={16} />
                        <span className={`${choiceModalMode === 'create' ? 'text-blue-100' : 'text-green-100'} font-medium`}>
                          {formData.items.filter(item => item.tallyItem).length} / {formData.items.length} items selected
                        </span>
                      </div>
                      <div className="flex items-center gap-2 bg-white bg-opacity-20 rounded-lg px-3 py-1">
                        <div className="w-16 h-2 bg-white bg-opacity-30 rounded-full overflow-hidden">
                          <div 
                            className="h-full bg-gradient-to-r from-green-400 to-emerald-400 transition-all duration-500"
                            style={{ width: `${getFormCompletionPercentage()}%` }}
                          />
                        </div>
                        <span className={`${choiceModalMode === 'create' ? 'text-blue-100' : 'text-green-100'} font-medium text-sm`}>
                          {getFormCompletionPercentage()}%
                        </span>
                      </div>
                      <div className="hidden md:flex items-center gap-1 bg-white bg-opacity-20 rounded-lg px-2 py-1">
                        <kbd className={`text-xs bg-white bg-opacity-30 ${choiceModalMode === 'create' ? 'text-blue-100' : 'text-green-100'} px-1 py-0.5 rounded`}>ESC</kbd>
                        <span className={`${choiceModalMode === 'create' ? 'text-blue-100' : 'text-green-100'} text-xs`}>to exit</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                onClick={handleChoiceBackNavigation}
                className="text-white hover:text-red-200 p-3 hover:bg-white hover:bg-opacity-20 rounded-xl transition-all duration-200 md:hidden"
              >
                <FaTimes size={24} />
              </button>
            </div>
          </div>

          {/* Scrollable Content Area */}
          <div className="flex-1 overflow-y-auto bg-gray-50"
            style={{
              scrollbarWidth: 'thin',
              scrollbarColor: '#e5e7eb #f3f4f6'
            }}
          >
            <form onSubmit={handleChoiceSubmit} className="p-8 space-y-8 w-full mx-auto pb-32">
              {/* Contact Type Selection with Enhanced Cards */}
              <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-6 border border-gray-200 shadow-sm">
                <label className="block text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <FaUsers className="text-blue-600" />
                  Contact Type <span className="text-red-500">*</span>
                </label>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  <label className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 ${
                    formData.contactType === 'Guest' 
                      ? 'border-blue-500 bg-blue-50 shadow-md' 
                      : 'border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-25'
                  }`}>
                    <input
                      type="radio"
                      value="Guest"
                      checked={formData.contactType === 'Guest'}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        contactType: e.target.value, 
                        guest: null, 
                        reference: null,
                        customer: null,
                        dealer: null
                      }))}
                      className="mr-3 h-4 w-4 text-blue-600"
                    />
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg ${formData.contactType === 'Guest' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'}`}>
                        <FaUser size={20} />
                      </div>
                      <div>
                        <span className="text-lg font-semibold text-gray-800">Guest</span>
                        <p className="text-sm text-gray-600">Select from registered guests</p>
                      </div>
                    </div>
                  </label>
                  <label className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 ${
                    formData.contactType === 'Reference' 
                      ? 'border-purple-500 bg-purple-50 shadow-md' 
                      : 'border-gray-200 bg-white hover:border-purple-300 hover:bg-purple-25'
                  }`}>
                    <input
                      type="radio"
                      value="Reference"
                      checked={formData.contactType === 'Reference'}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        contactType: e.target.value, 
                        guest: null, 
                        reference: null,
                        customer: null,
                        dealer: null
                      }))}
                      className="mr-3 h-4 w-4 text-purple-600"
                    />
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg ${formData.contactType === 'Reference' ? 'bg-purple-600 text-white' : 'bg-gray-200 text-gray-600'}`}>
                        <FaUsers size={20} />
                      </div>
                      <div>
                        <span className="text-lg font-semibold text-gray-800">Reference</span>
                        <p className="text-sm text-gray-600">Select from reference contacts</p>
                      </div>
                    </div>
                  </label>
                  <label className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 ${
                    formData.contactType === 'Customer' 
                      ? 'border-green-500 bg-green-50 shadow-md' 
                      : 'border-gray-200 bg-white hover:border-green-300 hover:bg-green-25'
                  }`}>
                    <input
                      type="radio"
                      value="Customer"
                      checked={formData.contactType === 'Customer'}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        contactType: e.target.value, 
                        guest: null, 
                        reference: null,
                        customer: null,
                        dealer: null
                      }))}
                      className="mr-3 h-4 w-4 text-green-600"
                    />
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg ${formData.contactType === 'Customer' ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-600'}`}>
                        <FaUserTie size={20} />
                      </div>
                      <div>
                        <span className="text-lg font-semibold text-gray-800">Customer</span>
                        <p className="text-sm text-gray-600">Select from registered customers</p>
                      </div>
                    </div>
                  </label>
                  <label className={`flex items-center p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 ${
                    formData.contactType === 'Dealer' 
                      ? 'border-orange-500 bg-orange-50 shadow-md' 
                      : 'border-gray-200 bg-white hover:border-orange-300 hover:bg-orange-25'
                  }`}>
                    <input
                      type="radio"
                      value="Dealer"
                      checked={formData.contactType === 'Dealer'}
                      onChange={(e) => setFormData(prev => ({ 
                        ...prev, 
                        contactType: e.target.value, 
                        guest: null, 
                        reference: null,
                        customer: null,
                        dealer: null
                      }))}
                      className="mr-3 h-4 w-4 text-orange-600"
                    />
                    <div className="flex items-center gap-3">
                      <div className={`p-2 rounded-lg ${formData.contactType === 'Dealer' ? 'bg-orange-600 text-white' : 'bg-gray-200 text-gray-600'}`}>
                        <FaBuilding size={20} />
                      </div>
                      <div>
                        <span className="text-lg font-semibold text-gray-800">Dealer</span>
                        <p className="text-sm text-gray-600">Select from registered dealers</p>
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              {/* Enhanced Contact Selection */}
              {formData.contactType === 'Guest' ? (
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-200 shadow-sm">
                  <label className="block text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FaUser className="text-blue-600" />
                    Guest Selection <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4">
                    <div className="flex-1 p-4 border-2 border-dashed border-gray-300 rounded-xl bg-white min-h-[80px] flex items-center">
                      {formData.guest ? (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-blue-600 text-white rounded-lg">
                              <FaUser size={16} />
                            </div>
                            <div>
                              <span className="font-bold text-gray-800 text-lg">{formData.guest.guestName}</span>
                              {formData.guest.phoneNo && (
                                <p className="text-gray-600 text-sm">📞 {formData.guest.phoneNo}</p>
                              )}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, guest: null }))}
                            className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
                          >
                            <FaTimes size={18} />
                          </button>
                        </div>
                      ) : (
                        <div className="text-center w-full text-gray-500">
                          <FaUser className="mx-auto mb-2 text-gray-400" size={24} />
                          <span>No guest selected</span>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col gap-2">
                      <button
                        type="button"
                        onClick={() => setShowGuestModal(true)}
                        className="px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2 font-semibold text-sm"
                      >
                        <FaUser size={16} />
                        Select Guest
                      </button>
                      <button
                        type="button"
                        onClick={() => setShowCreateGuestModal(true)}
                        className="px-6 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2 font-semibold text-sm"
                      >
                        <FaPlus size={16} />
                        Create New
                      </button>
                    </div>
                  </div>
                </div>
              ) : formData.contactType === 'Customer' ? (
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-200 shadow-sm">
                  <label className="block text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FaUserTie className="text-green-600" />
                    Customer Selection <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4">
                    <div className="flex-1 p-4 border-2 border-dashed border-gray-300 rounded-xl bg-white min-h-[80px] flex items-center">
                      {formData.customer ? (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-green-600 text-white rounded-lg">
                              <FaUserTie size={16} />
                            </div>
                            <div>
                              <span className="font-bold text-gray-800 text-lg">{formData.customer.name}</span>
                              {formData.customer.phone && (
                                <p className="text-gray-600 text-sm">📞 {formData.customer.phone}</p>
                              )}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, customer: null }))}
                            className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
                          >
                            <FaTimes size={18} />
                          </button>
                        </div>
                      ) : (
                        <div className="text-center w-full text-gray-500">
                          <FaUserTie className="mx-auto mb-2 text-gray-400" size={24} />
                          <span>No customer selected</span>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col gap-2">
                      <button
                        type="button"
                        onClick={() => setShowCustomerModal(true)}
                        className="px-6 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2 font-semibold text-sm"
                      >
                        <FaUserTie size={16} />
                        Select Customer
                      </button>
                    </div>
                  </div>
                </div>
              ) : formData.contactType === 'Dealer' ? (
                <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-6 border border-orange-200 shadow-sm">
                  <label className="block text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FaBuilding className="text-orange-600" />
                    Dealer Selection <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4">
                    <div className="flex-1 p-4 border-2 border-dashed border-gray-300 rounded-xl bg-white min-h-[80px] flex items-center">
                      {formData.dealer ? (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-orange-600 text-white rounded-lg">
                              <FaBuilding size={16} />
                            </div>
                            <div>
                              <span className="font-bold text-gray-800 text-lg">{formData.dealer.businessName}</span>
                              {formData.dealer.phone && (
                                <p className="text-gray-600 text-sm">📞 {formData.dealer.phone}</p>
                              )}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, dealer: null }))}
                            className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
                          >
                            <FaTimes size={18} />
                          </button>
                        </div>
                      ) : (
                        <div className="text-center w-full text-gray-500">
                          <FaBuilding className="mx-auto mb-2 text-gray-400" size={24} />
                          <span>No dealer selected</span>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col gap-2">
                      <button
                        type="button"
                        onClick={() => setShowDealerModal(true)}
                        className="px-6 py-2 bg-gradient-to-r from-orange-600 to-orange-700 text-white rounded-xl hover:from-orange-700 hover:to-orange-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2 font-semibold text-sm"
                      >
                        <FaBuilding size={16} />
                        Select Dealer
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl p-6 border border-purple-200 shadow-sm">
                  <label className="block text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <FaUsers className="text-purple-600" />
                    Reference Selection <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4">
                    <div className="flex-1 p-4 border-2 border-dashed border-gray-300 rounded-xl bg-white min-h-[80px] flex items-center">
                      {formData.reference ? (
                        <div className="flex items-center justify-between w-full">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-purple-600 text-white rounded-lg">
                              <FaUsers size={16} />
                            </div>
                            <div>
                              <span className="font-bold text-gray-800 text-lg">{formData.reference.name}</span>
                              <div className="flex gap-2 text-sm">
                                {formData.reference.phoneNumber && (
                                  <span className="text-gray-600">📞 {formData.reference.phoneNumber}</span>
                                )}
                                {formData.reference.type && (
                                  <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-lg font-medium">
                                    {formData.reference.type}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => setFormData(prev => ({ ...prev, reference: null }))}
                            className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
                          >
                            <FaTimes size={18} />
                          </button>
                        </div>
                      ) : (
                        <div className="text-center w-full text-gray-500">
                          <FaUsers className="mx-auto mb-2 text-gray-400" size={24} />
                          <span>No reference selected</span>
                        </div>
                      )}
                    </div>
                    <div className="flex flex-col gap-2">
                      <button
                        type="button"
                        onClick={() => setShowReferenceModal(true)}
                        className="px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl hover:from-purple-700 hover:to-purple-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2 font-semibold text-sm"
                      >
                        <FaUsers size={16} />
                        Select Reference
                      </button>
                      <button
                        type="button"
                        onClick={() => setShowCreateReferenceModal(true)}
                        className="px-6 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white rounded-xl hover:from-green-700 hover:to-green-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2 font-semibold text-sm"
                      >
                        <FaPlus size={16} />
                        Create New
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Enhanced Items Section - Compact */}
              <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-xl p-4 border border-green-200 shadow-sm">
                <div className="flex justify-between items-center mb-4">
                  <label className="block text-lg font-bold text-gray-800 flex items-center gap-2">
                    <FaCubes className="text-green-600" />
                    Items <span className="text-red-500">*</span>
                  </label>
                  <button
                    type="button"
                    onClick={addItemRow}
                    className="px-3 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2 font-semibold text-sm"
                  >
                    <FaPlus size={14} />
                    Add Item
                  </button>
                </div>

                <div className="space-y-4">
                  {formData.items.map((item, index) => (
                    <div key={index} className="bg-white border-2 border-gray-200 rounded-xl p-4 shadow-lg hover:shadow-xl transition-all duration-200 relative">
                      {/* Item Header */}
                      <div className="flex justify-between items-center mb-3">
                        <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                          <span className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-2 py-1 rounded text-sm font-bold">
                            #{index + 1}
                          </span>
                          Item Details
                        </h3>
                        {formData.items.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeItemRow(index)}
                            className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-xl transition-colors"
                            title="Remove item"
                          >
                            <FaTrash size={16} />
                          </button>
                        )}
                      </div>

                      {/* Compact Grid Layout */}
                      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">
                        {/* Compact Item Selection */}
                        <div className="lg:col-span-4">
                          <label className="block text-xs font-bold text-gray-700 mb-2 flex items-center gap-1">
                            <FaBox className="text-blue-600" size={12} />
                            Item Selection
                          </label>
                          <div className="flex gap-2">
                            <div className="flex-1 p-3 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 min-h-[80px] flex items-center">
                              {item.tallyItem ? (
                                <div className="w-full">
                                  <div className="flex items-center gap-2 mb-1">
                                    <div className="p-1 bg-blue-600 text-white rounded">
                                      <FaBox size={12} />
                                    </div>
                                    <div className="font-bold text-gray-800 text-sm">{item.tallyItem.Name}</div>
                                  </div>
                                  {item.tallyItem.parent && (
                                    <div className="text-xs text-gray-600 mb-1">
                                      📁 <span className="font-medium">{item.tallyItem.parent}</span>
                                    </div>
                                  )}
                                  {item.tallyItem.baseUnits && (
                                    <div className="text-xs text-gray-600">
                                      📏 <span className="font-medium">{item.tallyItem.baseUnits}</span>
                                    </div>
                                  )}
                                  {item.tallyItem.parameter && (
                                    <div className="mt-1 p-1 bg-blue-50 rounded border border-blue-200">
                                      <div className="text-xs text-blue-700">
                                        {item.tallyItem.parameter.calculationType === 'pcsPerBox' ? 'Pieces per Box' : 'Simple Pieces'}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="text-center w-full text-gray-500">
                                  <FaBox className="mx-auto mb-1 text-gray-400" size={24} />
                                  <span className="font-medium text-sm">No item selected</span>
                                </div>
                              )}
                            </div>
                            <div className="flex flex-col gap-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedItemIndex(index);
                                  setShowItemModal(true);
                                }}
                                className="px-2 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-1 font-semibold text-xs"
                                title="Select Item"
                              >
                                <FaBox size={12} />
                                Select
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedItemIndex(index);
                                  openQRScanner();
                                }}
                                className="px-2 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-1 font-semibold text-xs"
                                title="Scan QR Code"
                              >
                                <FaQrcode size={12} />
                                QR
                              </button>
                              {item.tallyItem && (
                                <button
                                  type="button"
                                  onClick={() => handleViewItemDetails(item.tallyItem)}
                                  className="px-2 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg hover:from-purple-700 hover:to-purple-800 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-1 font-semibold text-xs"
                                  title="View Details"
                                >
                                  <FaEye size={12} />
                                  View
                                </button>
                              )}
                            </div>
                          </div>
                          {/* Stock Summary by Location */}
                          {item.tallyItem && item.tallyItem.stockSummary && item.tallyItem.stockSummary.length > 0 && (
                            <div className="mt-3 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-3">
                              <div className="flex items-center gap-2 mb-2">
                                <div className="p-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded">
                                  <FaBox size={12} />
                                </div>
                                <h5 className="text-sm font-bold text-blue-800">Stock by Location</h5>
                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                                {item.tallyItem.stockSummary.map((stock, stockIndex) => (
                                  <div key={stockIndex} className="bg-white p-2 rounded border border-blue-200">
                                    <div className="text-xs font-medium text-blue-700">
                                      {stock.location?.Name || 'Main Warehouse'}
                                    </div>
                                    <div className="text-sm font-bold text-blue-800">
                                      {(stock.quantity || 0).toLocaleString()} {item.tallyItem.baseUnits || 'units'}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                                                  </div>

                        {/* Enhanced Form Fields - Taking More Space */}
                        <div className="lg:col-span-8">
                          <div className="bg-gradient-to-r from-gray-50 to-blue-50 border border-gray-200 rounded-lg p-3">
                            {/* Compact Header */}
                            <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-200">
                              <div className="p-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded">
                                <FaEdit size={12} />
                              </div>
                              <h4 className="text-sm font-bold text-gray-800">Item Details & Quantities</h4>
                            </div>

                            {/* Compact Basic Information Grid */}
                            <div className={item.tallyItem && item.tallyItem.parameter && item.tallyItem.parameter.calculationType === 'pcsPerBox' ? 'grid grid-cols-1 md:grid-cols-4 gap-3 mb-3' : 'grid grid-cols-1 md:grid-cols-2 gap-3 mb-3'}>
                              {/* Area Value Input for pcsPerBox items */}
                              {item.tallyItem && item.tallyItem.parameter && item.tallyItem.parameter.calculationType === 'pcsPerBox' && item.tallyItem.parameter.coverageArea && (
                                <div className="space-y-1">
                                  <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                    <FaRulerCombined className="text-purple-600" size={10} />
                                    Area Value
                                  </label>
                                  <div className="relative">
                                    <input
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      value={item.areaValue || ''}
                                      onChange={(e) => {
                                        const value = parseFloat(e.target.value) || 0;
                                        updateItemField(index, 'areaValue', value);
                                      }}
                                      onBlur={(e) => {
                                        const value = parseFloat(e.target.value) || 0;
                                        updateItemField(index, 'areaValue', Math.max(0, value));
                                      }}
                                      className={`w-full px-3 py-2 border rounded-lg text-sm font-bold text-center transition-all duration-200 ${
                                        (item.areaValue || 0) <= 0 
                                          ? 'border-purple-300 focus:ring-1 focus:ring-purple-500 focus:border-purple-500 bg-purple-50' 
                                          : 'border-purple-300 focus:ring-1 focus:ring-purple-500 focus:border-purple-500 bg-white'
                                      }`}
                                      placeholder="0"
                                    />
                                    <div className="absolute -bottom-4 left-0 text-xs text-purple-600">
                                      {item.tallyItem.parameter.coverageAreaUnit || 'sqft'}
                                    </div>
                                  </div>
                                </div>
                              )}
                              
                              {/* Quantity */}
                              <div className="space-y-1">
                                <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                  <FaCalculator className="text-green-600" size={10} />
                                  {item.calculationType === 'pcsPerBox' ? 'Total Pieces' : 'Quantity'}
                                </label>
                                <div className="relative">
                                  <input
                                    type="number"
                                    min="1"
                                    step="1"
                                    value={item.quantity}
                                    onChange={(e) => {
                                      const value = parseInt(e.target.value) || 0;
                                      if (value > 0) {
                                        updateItemField(index, 'quantity', value);
                                      }
                                    }}
                                    onBlur={(e) => {
                                      const value = parseInt(e.target.value) || 0;
                                      if (value <= 0) {
                                        updateItemField(index, 'quantity', 1);
                                      }
                                    }}
                                    data-item-index={index}
                                    data-field="quantity"
                                    className={`w-full px-3 py-2 border rounded-lg text-sm font-bold text-center transition-all duration-200 ${
                                      item.calculationType === 'pcsPerBox' 
                                        ? 'border-gray-200 bg-gray-50 text-gray-600 cursor-not-allowed' 
                                        : item.quantity <= 0 
                                          ? 'border-red-300 focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-red-50' 
                                          : 'border-green-300 focus:ring-1 focus:ring-green-500 focus:border-green-500 bg-white'
                                    }`}
                                    disabled={item.calculationType === 'pcsPerBox'}
                                    placeholder="1"
                                  />
                                  {item.calculationType === 'pcsPerBox' && (
                                    <div className="absolute -bottom-4 left-0 text-xs text-gray-500">
                                      Auto-calculated
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Price */}
                              <div className="space-y-1">
                                <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                  <FaRupeeSign className="text-yellow-600" size={10} />
                                  {item.tallyItem && item.tallyItem.parameter && item.tallyItem.parameter.calculationType === 'pcsPerBox' ? 'Price/Box' : 'Unit Price'}
                                </label>
                                <div className="relative">
                                  <FaRupeeSign className="absolute left-2 top-1/2 transform -translate-y-1/2 text-yellow-600" size={10} />
                                  <input
                                    type="number"
                                    min="0.01"
                                    step="0.01"
                                    value={item.price}
                                    onChange={(e) => {
                                      const value = parseFloat(e.target.value) || 0;
                                      updateItemField(index, 'price', value);
                                    }}
                                    onBlur={(e) => {
                                      const value = parseFloat(e.target.value) || 0;
                                      if (value <= 0) {
                                        // Show warning but allow 0 for draft entries
                                        updateItemField(index, 'price', 0);
                                      }
                                    }}
                                    className={`w-full pl-6 pr-3 py-2 border rounded-lg focus:ring-1 text-sm font-bold text-center transition-all duration-200 ${
                                      item.price <= 0 
                                        ? 'border-red-300 focus:ring-red-500 focus:border-red-500 bg-red-50' 
                                        : 'border-yellow-300 focus:ring-yellow-500 focus:border-yellow-500 bg-white'
                                    }`}
                                    placeholder="0.00"
                                  />
                                  {item.price <= 0 && (
                                    <div className="absolute -bottom-4 left-0 text-xs text-red-500">
                                      Price should be greater than 0
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Price per Sqft - Only for pcsPerBox items */}
                              {item.calculationType === 'pcsPerBox' && item.tallyItem?.parameter && (
                                <div className="space-y-1">
                                  <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                    <FaRupeeSign className="text-purple-600" size={10} />
                                    Price per {item.areaUnit === 'sqft' ? 'Sq.Ft' : 'Sq.M'}
                                  </label>
                                  <div className="relative">
                                    <FaRupeeSign className="absolute left-2 top-1/2 transform -translate-y-1/2 text-purple-600" size={10} />
                                    <input
                                      type="number"
                                      min="0.01"
                                      step="0.01"
                                      value={item.pricePerSqft}
                                      onChange={(e) => {
                                        const value = parseFloat(e.target.value) || 0;
                                        updateItemField(index, 'pricePerSqft', value);
                                      }}
                                      onBlur={(e) => {
                                        const value = parseFloat(e.target.value) || 0;
                                        if (value <= 0) {
                                          updateItemField(index, 'pricePerSqft', 0);
                                        }
                                      }}
                                      className={`w-full pl-6 pr-3 py-2 border rounded-lg focus:ring-1 text-sm font-bold text-center transition-all duration-200 ${
                                        item.pricePerSqft <= 0 
                                          ? 'border-purple-300 focus:ring-purple-500 focus:border-purple-500 bg-purple-50' 
                                          : 'border-purple-300 focus:ring-purple-500 focus:border-purple-500 bg-white'
                                      }`}
                                      placeholder="0.00"
                                    />
                                    <div className="absolute -bottom-4 left-0 text-xs text-purple-500">
                                      Updates box price automatically
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            {/* Compact Total Amount Display */}
                            <div className="mb-3">
                              <label className="block text-xs font-bold text-gray-700 mb-1 flex items-center gap-1">
                                <FaChartLine className="text-green-600" size={10} />
                                Total Amount
                              </label>
                              <div className="w-full px-4 py-2 border border-green-200 rounded-lg bg-gradient-to-r from-green-50 via-emerald-50 to-green-50 shadow-inner">
                                <div className="text-center">
                                  <div className="text-lg font-bold text-green-700">
                                    ₹{(item.amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </div>
                                  <div className="text-xs text-green-600">
                                    {item.calculationType === 'pcsPerBox' 
                                      ? `(${((item.boxQuantity || 0) + ((item.pcsQuantity || 0) / (item.tallyItem?.parameter?.piecesPerBox || 1))).toFixed(2)} equiv. boxes × ₹${item.price || 0})`
                                      : `(${item.quantity || 0} units × ₹${item.price || 0})`
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* PcsPerBox-specific fields - Compact */}
                            {item.tallyItem && item.tallyItem.parameter && item.tallyItem.parameter.calculationType === 'pcsPerBox' && (
                              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-3 border border-blue-200 mb-3">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="p-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded">
                                    <FaCubes size={10} />
                                  </div>
                                  <h5 className="text-sm font-bold text-blue-800">Box & Pieces Breakdown</h5>
                                  <div className="text-xs text-blue-600 bg-blue-100 px-2 py-1 rounded-full">
                                    {item.tallyItem.parameter.piecesPerBox} pcs/box
                                  </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                  {/* Box Quantity */}
                                  <div className="space-y-1">
                                    <label className="block text-xs font-bold text-blue-700 flex items-center gap-1">
                                      <FaCube className="text-blue-600" size={10} />
                                      Full Boxes
                                    </label>
                                    <input
                                      type="number"
                                      min="0"
                                      step="1"
                                      value={item.boxQuantity}
                                      onChange={(e) => {
                                        const value = parseInt(e.target.value) || 0;
                                        updateItemField(index, 'boxQuantity', Math.max(0, value));
                                      }}
                                      onBlur={(e) => {
                                        const boxQty = parseInt(e.target.value) || 0;
                                        const pcsQty = item.pcsQuantity || 0;
                                        // Ensure at least some quantity (either boxes or pieces)
                                        if (boxQty === 0 && pcsQty === 0) {
                                          updateItemField(index, 'boxQuantity', 1);
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm font-bold text-center transition-all duration-200 ${
                                        (item.boxQuantity || 0) === 0 && (item.pcsQuantity || 0) === 0
                                          ? 'border-red-300 bg-red-50'
                                          : 'border-blue-300'
                                      }`}
                                      placeholder="0"
                                    />
                                    <div className="text-xs text-blue-600 text-center">
                                      = {((item.boxQuantity || 0) * (item.tallyItem?.parameter?.piecesPerBox || 1)).toLocaleString()} pieces
                                    </div>
                                    {(item.boxQuantity || 0) === 0 && (item.pcsQuantity || 0) === 0 && (
                                      <div className="text-xs text-red-500 text-center">
                                        Enter boxes or pieces
                                      </div>
                                    )}
                                  </div>

                                  {/* Additional Pieces */}
                                  <div className="space-y-1">
                                    <label className="block text-xs font-bold text-blue-700 flex items-center gap-1">
                                      <FaPlus className="text-blue-600" size={10} />
                                      Additional Pieces
                                    </label>
                                    <input
                                      type="number"
                                      min="0"
                                      max={Math.max(0, (item.tallyItem?.parameter?.piecesPerBox || 1) - 1)}
                                      step="1"
                                      value={item.pcsQuantity}
                                      onChange={(e) => {
                                        const value = parseInt(e.target.value) || 0;
                                        const maxPieces = Math.max(0, (item.tallyItem?.parameter?.piecesPerBox || 1) - 1);
                                        updateItemField(index, 'pcsQuantity', Math.min(Math.max(0, value), maxPieces));
                                      }}
                                      onBlur={(e) => {
                                        const pcsQty = parseInt(e.target.value) || 0;
                                        const boxQty = item.boxQuantity || 0;
                                        // Ensure at least some quantity (either boxes or pieces)
                                        if (boxQty === 0 && pcsQty === 0) {
                                          updateItemField(index, 'pcsQuantity', 1);
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm font-bold text-center transition-all duration-200 ${
                                        (item.boxQuantity || 0) === 0 && (item.pcsQuantity || 0) === 0
                                          ? 'border-red-300 bg-red-50'
                                          : 'border-blue-300'
                                      }`}
                                      placeholder="0"
                                    />
                                    <div className="text-xs text-blue-600 text-center">
                                      Max: {Math.max(0, (item.tallyItem?.parameter?.piecesPerBox || 1) - 1)} pieces
                                    </div>
                                    {(item.boxQuantity || 0) === 0 && (item.pcsQuantity || 0) === 0 && (
                                      <div className="text-xs text-red-500 text-center">
                                        Enter boxes or pieces
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Compact Summary */}
                                <div className="mt-2 p-2 bg-white rounded border border-blue-200">
                                  <div className="text-center text-blue-800">
                                    <div className="text-sm font-bold">
                                      Total: {((item.boxQuantity || 0) * (item.tallyItem?.parameter?.piecesPerBox || 1) + (item.pcsQuantity || 0)).toLocaleString()} pieces
                                    </div>
                                    <div className="text-xs text-blue-600">
                                      ({item.boxQuantity || 0} boxes + {item.pcsQuantity || 0} pieces)
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Area-based fields - Compact */}
                            {item.tallyItem && item.tallyItem.parameter && (item.tallyItem.parameter.heightRequired || item.tallyItem.parameter.widthRequired) && (
                              <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-3 border border-purple-200">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="p-1 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded">
                                    <FaRulerCombined size={10} />
                                  </div>
                                  <h5 className="text-sm font-bold text-purple-800">Area Calculation</h5>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                  {/* Area Value */}
                                  <div className="space-y-1">
                                    <label className="block text-xs font-bold text-purple-700 flex items-center gap-1">
                                      <FaExpand className="text-purple-600" size={10} />
                                      Area Value
                                    </label>
                                    <input
                                      type="number"
                                      min="0.01"
                                      step="0.01"
                                      value={item.areaValue}
                                      onChange={(e) => {
                                        const value = parseFloat(e.target.value) || 0;
                                        updateItemField(index, 'areaValue', Math.max(0, value));
                                      }}
                                      onBlur={(e) => {
                                        const value = parseFloat(e.target.value) || 0;
                                        if (value <= 0 && (item.tallyItem?.parameter?.heightRequired || item.tallyItem?.parameter?.widthRequired)) {
                                          // For items requiring area, enforce minimum value
                                          updateItemField(index, 'areaValue', 0.01);
                                        }
                                      }}
                                      className={`w-full px-3 py-2 border rounded-lg focus:ring-1 focus:ring-purple-500 focus:border-purple-500 text-sm font-bold text-center transition-all duration-200 ${
                                        item.areaValue <= 0 && (item.tallyItem?.parameter?.heightRequired || item.tallyItem?.parameter?.widthRequired)
                                          ? 'border-red-300 bg-red-50'
                                          : 'border-purple-300'
                                      }`}
                                      placeholder="0.00"
                                    />
                                    {item.areaValue <= 0 && (item.tallyItem?.parameter?.heightRequired || item.tallyItem?.parameter?.widthRequired) && (
                                      <div className="text-xs text-red-500 text-center">
                                        Area value required
                                      </div>
                                    )}
                                  </div>

                                  {/* Area Unit */}
                                  <div className="space-y-1">
                                    <label className="block text-xs font-bold text-purple-700 flex items-center gap-1">
                                      <FaRuler className="text-purple-600" size={10} />
                                      Unit
                                    </label>
                                    <select
                                      value={item.areaUnit}
                                      onChange={(e) => updateItemField(index, 'areaUnit', e.target.value)}
                                      className="w-full px-3 py-2 border border-purple-300 rounded-lg focus:ring-1 focus:ring-purple-500 focus:border-purple-500 text-sm font-bold text-center transition-all duration-200"
                                    >
                                      <option value="sq_ft">Square Feet</option>
                                      <option value="sq_m">Square Meters</option>
                                      <option value="sq_inch">Square Inches</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Additional Item Details Section */}
                            <div className="bg-gradient-to-r from-gray-50 to-slate-50 rounded-lg p-3 border border-gray-200">
                              <div className="flex items-center gap-2 mb-3">
                                <div className="p-1 bg-gradient-to-r from-gray-600 to-slate-600 text-white rounded">
                                  <FaEdit size={10} />
                                </div>
                                <h5 className="text-sm font-bold text-gray-800">Additional Details</h5>
                              </div>

                              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {/* Application Area */}
                                <div className="space-y-1">
                                  <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                    <FaMapMarkerAlt className="text-orange-600" size={10} />
                                    Application Area
                                  </label>
                                  <input
                                    type="text"
                                    value={item.applicationArea || ''}
                                    onChange={(e) => updateItemField(index, 'applicationArea', e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-orange-500 focus:border-orange-500 text-sm transition-all duration-200"
                                    placeholder="e.g., Living Room, Kitchen"
                                  />
                                </div>


                                {/* Markup */}
                                <div className="space-y-1">
                                  <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                    <FaPercent className="text-emerald-600" size={10} />
                                    Markup
                                  </label>
                                  <input
                                    type="text"
                                    value={item.markup || ''}
                                    onChange={(e) => updateItemField(index, 'markup', e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 text-sm transition-all duration-200"
                                    placeholder="e.g., 10%, Fixed 100"
                                  />
                                </div>

                                {/* Remarks */}
                                <div className="space-y-1">
                                  <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                    <FaComment className="text-pink-600" size={10} />
                                    Remarks
                                  </label>
                                  <input
                                    type="text"
                                    value={item.remarks || ''}
                                    onChange={(e) => updateItemField(index, 'remarks', e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-pink-500 focus:border-pink-500 text-sm transition-all duration-200"
                                    placeholder="Special notes or comments"
                                  />
                                </div>

                                {/* Availability */}
                                <div className="space-y-1">
                                  <label className="block text-xs font-bold text-gray-700 flex items-center gap-1">
                                    <FaClipboardList className="text-teal-600" size={10} />
                                    Availability
                                  </label>
                                  <input
                                    type="text"
                                    value={item.availability || ''}
                                    onChange={(e) => updateItemField(index, 'availability', e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-1 focus:ring-teal-500 focus:border-teal-500 text-sm transition-all duration-200"
                                    placeholder="e.g., In Stock, 2-3 days"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

              {/* Enhanced Payment Remark Section */}
              <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-2xl p-6 border border-yellow-200 shadow-sm">
                <label className="block text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                  <FaEdit className="text-yellow-600" />
                  Payment Remark
                </label>
                <textarea
                  value={formData.paymentRemark}
                  onChange={(e) => setFormData(prev => ({ ...prev, paymentRemark: e.target.value }))}
                  placeholder="Enter payment remark (optional)"
                  rows={4}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-base transition-all duration-200 resize-none"
                />
              </div>

              {/* Enhanced Total Amount Summary */}
              <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 rounded-2xl p-6 shadow-2xl">
                <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
                  <div className="p-3 bg-white bg-opacity-20 rounded-xl">
                    <FaShoppingCart size={24} />
                  </div>
                  Choice Summary
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-xl border border-white border-opacity-20">
                    <div className="flex items-center gap-3 mb-2">
                      <FaCubes className="text-white" size={20} />
                      <span className="text-white font-semibold">Total Items</span>
                    </div>
                    <div className="text-3xl font-bold text-white">
                      {formData.items.filter(item => item.tallyItem).length}
                    </div>
                    <div className="text-blue-100 text-sm mt-1">Selected items</div>
                  </div>
                  <div className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-xl border border-white border-opacity-20">
                    <div className="flex items-center gap-3 mb-2">
                      <FaCalculator className="text-white" size={20} />
                      <span className="text-white font-semibold">Total Quantity</span>
                    </div>
                    <div className="text-3xl font-bold text-white">
                      {formData.items.reduce((sum, item) => {
                        if (item.calculationType === 'pcsPerBox' && item.tallyItem?.parameter) {
                          // For pcsPerBox, calculate total individual pieces: (boxes × piecesPerBox) + additional pieces
                          const boxes = item.boxQuantity || 0;
                          const additionalPieces = item.pcsQuantity || 0;
                          const piecesPerBox = item.tallyItem.parameter.piecesPerBox || 1;
                          return sum + (boxes * piecesPerBox) + additionalPieces;
                        } else {
                          // For regular pcs, use standard quantity
                          return sum + (parseFloat(item.quantity) || 0);
                        }
                      }, 0).toLocaleString('en-IN')}
                    </div>
                    <div className="text-blue-100 text-sm mt-1">Total pieces</div>
                  </div>
                  <div className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-xl border border-white border-opacity-20">
                    <div className="flex items-center gap-3 mb-2">
                      <FaRupeeSign className="text-white" size={20} />
                      <span className="text-white font-semibold">Total Amount</span>
                    </div>
                    <div className="text-3xl font-bold text-white">
                      ₹{formData.items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                    <div className="text-blue-100 text-sm mt-1">Grand total</div>
                  </div>
                </div>
              </div>

              {/* Enhanced Submit Buttons - Fixed at Bottom */}
              <div className="sticky bottom-0 left-0 right-0 bg-white border-t-2 border-gray-200 p-6 shadow-lg">
                <div className="flex flex-col sm:flex-row justify-end gap-4 w-full mx-auto">
                  <button
                    type="button"
                    onClick={handleBackNavigation}
                    className="px-8 py-4 border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 font-semibold text-lg flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                  >
                    <FaTimes size={20} />
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-10 py-4 bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 text-white rounded-xl hover:from-green-700 hover:via-emerald-700 hover:to-teal-700 transition-all duration-200 font-bold text-lg flex items-center justify-center gap-3 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1"
                  >
                    <FaCheck size={20} />
                    {editingChoice ? 'Update' : 'Create'} Choice
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Guest Selection Modal */}
      {showGuestModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[70vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-900">Select Guest</h2>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => {
                      setShowGuestModal(false);
                      setShowCreateGuestModal(true);
                    }}
                    className="px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-1"
                  >
                    <FaPlus size={12} />
                    Create New
                  </button>
                  <button
                    onClick={() => setShowGuestModal(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <FaTimes />
                  </button>
                </div>
              </div>
              <div className="relative">
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search guests..."
                  value={guestSearch}
                  onChange={(e) => setGuestSearch(e.target.value.toUpperCase())}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
            </div>

            <div className="p-6">
              {loadingGuests ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-500">Loading guests...</span>
                </div>
              ) : guests.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  No guests found
                </div>
              ) : (
                <div className="space-y-2 max-h-96 overflow-y-auto">
                  {guests.map((guest) => (
                    <div
                      key={guest._id}
                      onClick={() => handleGuestSelect(guest)}
                      className="p-3 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 cursor-pointer transition-colors duration-200"
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium text-gray-900">{guest.guestName}</div>
                          {guest.phoneNo && (
                            <div className="text-sm text-gray-500">{guest.phoneNo}</div>
                          )}
                          {guest.reference && (
                            <div className="text-xs text-gray-400">Ref: {guest.reference}</div>
                          )}
                        </div>
                        <div className="text-blue-600">
                          <FaCheck />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {guestPage < totalGuestPages && (
                <div className="mt-4 text-center">
                  <button
                    onClick={() => {
                      setGuestPage(prev => prev + 1);
                      loadGuests(guestPage + 1, guestSearch);
                    }}
                    className="px-4 py-2 text-blue-600 hover:text-blue-800"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Reference Selection Modal */}
      {showReferenceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[70vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-900">Select Reference</h2>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => {
                      setShowReferenceModal(false);
                      setShowCreateReferenceModal(true);
                    }}
                    className="px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-1"
                  >
                    <FaPlus size={12} />
                    Create New
                  </button>
                  <button
                    onClick={() => setShowReferenceModal(false)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <FaTimes />
                  </button>
                </div>
              </div>
              <div className="relative">
                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search references..."
                  value={referenceSearch}
                  onChange={(e) => setReferenceSearch(e.target.value.toUpperCase())}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
            </div>

            <div className="p-6">
              {loadingReferences ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-500">Loading references...</span>
                </div>
              ) : references.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  No references found
                </div>
              ) : (
                <div className="space-y-2 max-h-96 overflow-y-auto">
                  {references.map((reference) => (
                    <div
                      key={reference._id}
                      onClick={() => handleReferenceSelect(reference)}
                      className="p-3 border border-gray-200 rounded-lg hover:bg-purple-50 hover:border-purple-300 cursor-pointer transition-colors duration-200"
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium text-gray-900">{reference.name}</div>
                          {reference.phoneNumber && (
                            <div className="text-sm text-gray-500">{reference.phoneNumber}</div>
                          )}
                          <div className="flex gap-2 mt-1">
                            {reference.type && (
                              <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                                {reference.type}
                              </span>
                            )}
                            {reference.classification && (
                              <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded">
                                Class {reference.classification}
                              </span>
                            )}
                          </div>
                          {reference.station?.name && (
                            <div className="text-xs text-gray-400 mt-1">Station: {reference.station.name}</div>
                          )}
                        </div>
                        <div className="text-purple-600">
                          <FaCheck />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {referencePage < totalReferencePages && (
                <div className="mt-4 text-center">
                  <button
                    onClick={() => {
                      setReferencePage(prev => prev + 1);
                      loadReferences(referencePage + 1, referenceSearch);
                    }}
                    className="px-4 py-2 text-blue-600 hover:text-blue-800"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Item Selection Modal */}
      {showItemModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-4xl w-full max-h-[60vh] overflow-y-auto">{/* Reduced height from 80vh to 60vh */}
            <div className="p-6 border-b border-gray-200">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold text-gray-900">Select Item</h2>
                <button
                  onClick={() => setShowItemModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <FaTimes />
                </button>
              </div>
              <div className="flex gap-2 items-center">
                <div className="relative flex-1">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search items..."
                    value={itemSearch}
                    onChange={(e) => setItemSearch(e.target.value.toUpperCase())}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    style={{ textTransform: 'uppercase' }}
                  />
                </div>
                <button
                  onClick={openQRScanner}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
                  title="Scan QR Code"
                >
                  <FaQrcode />
                  Scan QR
                </button>
              </div>
            </div>

            <div className="p-6">
              {loadingItems ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                  <span className="ml-2 text-gray-500">Loading items...</span>
                </div>
              ) : tallyItems.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  No items found
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-72 overflow-y-auto">{/* Reduced max height for better fit */}
                  {tallyItems.map((item) => (
                    <div
                      key={item._id}
                      className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                    >
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="font-medium text-gray-900">{item.Name}</div>
                          {item.parent && (
                            <div className="text-sm text-gray-500">Group: {item.parent}</div>
                          )}
                          {item.baseUnits && (
                            <div className="text-xs text-gray-400">Unit: {item.baseUnits}</div>
                          )}
                          {item.category && (
                            <div className="text-xs text-gray-400">Category: {item.category}</div>
                          )}
                          {item.hsnCode && (
                            <div className="text-xs text-gray-400">HSN: {item.hsnCode}</div>
                          )}
                          {/* Price List Information */}
                          {item.pricelist && item.pricelist.length > 0 && (
                            <div className="mt-2 p-2 bg-green-50 rounded border-l-4 border-green-400">
                              <div className="text-xs font-medium text-green-800 mb-1 flex items-center gap-1">
                                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                Price List ({item.pricelist.length})
                              </div>
                              <div className="space-y-1">
                                {item.pricelist.slice(0, 2).map((priceEntry, priceIndex) => (
                                  <div key={priceIndex} className="text-xs text-green-700">
                                    {priceEntry.priceLevel && (
                                      <span className="font-medium">{priceEntry.priceLevel}: </span>
                                    )}
                                    {priceEntry.rates && priceEntry.rates.length > 0 && (
                                      <div className="font-bold">
                                        {/* Standard price with GST */}
                                        <div className="text-green-800">
                                          ₹{Math.ceil((priceEntry.rates[0].price || 0) * 1.18).toLocaleString('en-IN')}{priceEntry.rates[0].unit ? `/${priceEntry.rates[0].unit}` : ''} 
                                        </div>
                                        
                                        {/* Area unit pricing for pcsPerBox items */}
                                        {item.parameter?.calculationType === 'pcsPerBox' && item.parameter?.coverageArea && (
                                          <div className="mt-1 text-xs text-purple-700 bg-purple-100 px-2 py-1 rounded">
                                            ₹{Math.ceil(((priceEntry.rates[0].price || 0) * 1.18) / item.parameter.coverageArea).toLocaleString('en-IN')}/{item.parameter.coverageAreaUnit || 'sqft'} 
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    {/* Show area unit pricing even if parameter calculation type is not pcsPerBox but has coverage info */}
                                    {priceEntry.rates && priceEntry.rates.length > 0 && !item.parameter?.calculationType && item.parameter?.coverageArea && (
                                      <div className="text-xs text-gray-500">
                                        <div className="mt-1 text-xs text-purple-600 bg-purple-50 px-2 py-1 rounded">
                                          ₹{Math.ceil(((priceEntry.rates[0].price || 0) * 1.18) / item.parameter.coverageArea).toLocaleString('en-IN')}/{item.parameter.coverageAreaUnit || 'sqft'} 
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ))}
                                {item.pricelist.length > 2 && (
                                  <div className="text-xs text-green-600 italic">
                                    +{item.pricelist.length - 2} more price levels
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="flex flex-col gap-2 ml-3">
                          <button
                            onClick={() => handleItemSelect(item)}
                            className="flex items-center justify-center w-8 h-8 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                            title="Select Item"
                          >
                            <FaCheck size={14} />
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewItemDetails(item);
                            }}
                            className="flex items-center justify-center w-8 h-8 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                            title="View Details"
                          >
                            <FaEye size={14} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {itemPage < totalItemPages && (
                <div className="mt-4 text-center">
                  <button
                    onClick={() => {
                      setItemPage(prev => prev + 1);
                      loadTallyItems(itemPage + 1, itemSearch);
                    }}
                    className="px-4 py-2 text-blue-600 hover:text-blue-800"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Status Update Modal */}
      {showStatusModal && selectedChoice && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="px-6 py-4 border-b border-gray-200">
              <h3 className="text-lg font-medium text-gray-900">
                Update Choice Status
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Update status for choice {selectedChoice.id}
              </p>
            </div>
            
            <div className="px-6 py-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Guest
                </label>
                <p className="text-sm text-gray-900">
                  {selectedChoice.guest?.guestName} - {selectedChoice.guest?.phoneNo}
                </p>
              </div>
              
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Current Status
                </label>
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(selectedChoice.status)}`}>
                  {selectedChoice.status}
                </span>
              </div>
              
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  New Status *
                </label>
                {/* enum: ['Draft', 'Pending', 'Positive', 'Negative', 'Follow-up'], */}
                <Select
                  onChange={(selectedOption) => setNewStatus(selectedOption ? selectedOption.value : '')}
                  options={[
                    { value: 'Draft', label: 'Draft' },
                    { value: 'Pending', label: 'Pending' },
                    { value: 'Positive', label: 'Positive' },
                    { value: 'Negative', label: 'Negative' },
                    { value: 'Follow-up', label: 'Follow-up' }
                  ]}
                  placeholder="Select Status..."
                  className="react-select-container"
                  classNamePrefix="react-select"
                  styles={customSelectStyles}
                  isSearchable={false}
                />
              </div>
            </div>
            
            <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
              <button
                type="button"
                onClick={() => {
                  setShowStatusModal(false);
                  setSelectedChoice(null);
                  setNewStatus('');
                }}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleStatusUpdate}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700"
              >
                Update Status
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {showViewModal && viewingChoice && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
              <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                <FaEye className="text-indigo-600" />
                Choice Details - {viewingChoice.id}
              </h3>
              <button
                onClick={() => {
                  setShowViewModal(false);
                  setViewingChoice(null);
                }}
                className="text-gray-400 hover:text-gray-600 p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FaTimes size={20} />
              </button>
            </div>
            <div className="p-6 space-y-6">
              {/* Basic Information */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Basic Information</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Choice ID:</span>
                    <div className="font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded text-sm font-mono">{viewingChoice.id}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Status:</span>
                    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(viewingChoice.status)}`}>
                      {viewingChoice.status}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Contact Type:</span>
                    <div className="font-medium bg-blue-50 text-blue-800 px-2 py-1 rounded text-sm">
                      {viewingChoice.contactType}
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Total Items:</span>
                    <div className="font-medium text-gray-700">{viewingChoice.totalItems || viewingChoice.items?.length || 0}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Created By:</span>
                    <div className="font-medium text-gray-700">{viewingChoice.createdBy?.name || 'Unknown'}</div>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-500">Created At:</span>
                    <div className="font-medium text-gray-700 text-sm">
                      {new Date(viewingChoice.createdAt).toLocaleString()}
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">
                  {viewingChoice.contactType === 'Reference' ? 'Reference Information' : 'Guest Information'}
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {viewingChoice.contactType === 'Reference' ? (
                    <>
                      <div>
                        <span className="text-sm text-gray-500">Reference Name:</span>
                        <div className="mt-1 p-3 bg-green-50 border border-green-200 rounded">
                          <div className="font-medium text-green-800">{viewingChoice.reference?.name || 'N/A'}</div>
                        </div>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Phone Number:</span>
                        <div className="mt-1 p-3 bg-blue-50 border border-blue-200 rounded">
                          <div className="font-medium text-blue-800">{viewingChoice.reference?.phoneNumber || 'N/A'}</div>
                        </div>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Type:</span>
                        <div className="mt-1 p-3 bg-purple-50 border border-purple-200 rounded">
                          <div className="font-medium text-purple-800">{viewingChoice.reference?.type || 'N/A'}</div>
                        </div>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Classification:</span>
                        <div className="mt-1 p-3 bg-orange-50 border border-orange-200 rounded">
                          <div className="font-medium text-orange-800">{viewingChoice.reference?.classification || 'N/A'}</div>
                        </div>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Station:</span>
                        <div className="mt-1 p-3 bg-yellow-50 border border-yellow-200 rounded">
                          <div className="font-medium text-yellow-800">{viewingChoice.reference?.station?.name || 'N/A'}</div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <span className="text-sm text-gray-500">Guest Name:</span>
                        <div className="mt-1 p-3 bg-green-50 border border-green-200 rounded">
                          <div className="font-medium text-green-800">{viewingChoice.guest?.guestName || 'N/A'}</div>
                        </div>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Phone Number:</span>
                        <div className="mt-1 p-3 bg-blue-50 border border-blue-200 rounded">
                          <div className="font-medium text-blue-800">{viewingChoice.guest?.phoneNo || 'N/A'}</div>
                        </div>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Reference:</span>
                        <div className="mt-1 p-3 bg-purple-50 border border-purple-200 rounded">
                          <div className="font-medium text-purple-800">{viewingChoice.guest?.reference || 'N/A'}</div>
                        </div>
                      </div>
                      <div>
                        <span className="text-sm text-gray-500">Station:</span>
                        <div className="mt-1 p-3 bg-yellow-50 border border-yellow-200 rounded">
                          <div className="font-medium text-yellow-800">{viewingChoice.guest?.station?.name || 'N/A'}</div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Selected Items */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                  <FaBox className="text-blue-600" />
                  Selected Items ({viewingChoice.items?.length || 0})
                </h4>
                <div className="space-y-4">
                  {viewingChoice.items && viewingChoice.items.length > 0 ? (
                    viewingChoice.items.map((item, index) => (
                      <div key={index} className="p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                        <div className="mb-3">
                          <h5 className="font-semibold text-blue-800 flex items-center gap-2">
                            <FaCube className="text-blue-600" />
                            {item.tallyItem?.Name || 'Unknown Item'}
                          </h5>
                          <div className="flex flex-wrap gap-2 mt-2">
                            {item.tallyItem?.parent && (
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                Group: {item.tallyItem.parent}
                              </span>
                            )}
                            {item.tallyItem?.category && (
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                Category: {item.tallyItem.category}
                              </span>
                            )}
                            {item.tallyItem?.hsnCode && (
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                                HSN: {item.tallyItem.hsnCode}
                              </span>
                            )}
                            {item.tallyItem?.baseUnits && (
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                Unit: {item.tallyItem.baseUnits}
                              </span>
                            )}
                          </div>
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                          <div className="space-y-2">
                            <div className="bg-white p-3 rounded border border-blue-300">
                              <span className="text-xs text-gray-600 font-medium block mb-1">Quantity</span>
                              <div className="flex items-center justify-between">
                                {item.tallyItem?.parameter?.calculationType === 'pcsPerBox' ? (
                                  <div className="text-sm">
                                    {item.areaValue > 0 && (
                                      <div className="mb-1">
                                        <span className="text-purple-600 font-medium">
                                          Area: {item.areaValue} {item.tallyItem.parameter.coverageAreaUnit || 'sqft'}
                                        </span>
                                      </div>
                                    )}
                                    <div className="font-medium">
                                      {item.boxQuantity || 0} Box{(item.boxQuantity || 0) !== 1 ? 'es' : ''} + {item.pcsQuantity || 0} Pcs
                                    </div>
                                    <div className="text-xs text-gray-500">
                                      Total: {item.quantity} pieces
                                    </div>
                                  </div>
                                ) : (
                                  <span className="font-bold text-lg text-blue-700">
                                    {item.quantity}
                                  </span>
                                )}
                                <span className="text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded">
                                  {item.uom || item.tallyItem?.baseUnits || 'units'}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="space-y-2">
                            <div className="bg-white p-3 rounded border border-green-300">
                              <span className="text-xs text-gray-600 font-medium block mb-1">Price</span>
                              <div className="flex items-center justify-between">
                                <span className="font-bold text-lg text-green-700">
                                  ₹{item.price || 0}
                                </span>
                                <span className="text-sm text-gray-600 bg-gray-100 px-2 py-1 rounded">
                                  per {item.tallyItem?.parameter?.calculationType === 'pcsPerBox' ? 'box' : item.tallyItem?.baseUnits || item.uom}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="space-y-2">
                            <div className="bg-white p-3 rounded border border-yellow-300">
                              <span className="text-xs text-gray-600 font-medium block mb-1">Markup</span>
                              <div className="flex items-center justify-between">
                                <span className="font-bold text-lg text-yellow-700">
                                  {item.markup || '-'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Additional Details */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                          <div>
                            <span className="text-xs text-gray-600 font-medium">Application Area:</span>
                            <div className="mt-1 p-2 bg-white rounded border border-gray-200">
                              <div className="text-sm text-gray-700">{item.applicationArea || 'Not specified'}</div>
                            </div>
                          </div>
                          <div>
                            <span className="text-xs text-gray-600 font-medium">Remarks:</span>
                            <div className="mt-1 p-2 bg-white rounded border border-gray-200">
                              <div className="text-sm text-gray-700">{item.remarks || 'No remarks'}</div>
                            </div>
                          </div>
                        </div>

                        {/* Tally Item Details */}
                        {item.tallyItem && (
                          <div className="mt-4 p-3 bg-gray-50 rounded border border-gray-200">
                            <h6 className="font-medium text-gray-800 mb-2">Tally Item Details</h6>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                              {item.tallyItem.GUID && (
                                <div>
                                  <span className="text-gray-600">GUID:</span>
                                  <div className="font-mono text-xs text-gray-700 bg-gray-100 px-2 py-1 rounded mt-1">
                                    {item.tallyItem.GUID}
                                  </div>
                                </div>
                              )}
                              {item.tallyItem.gstApplicable && (
                                <div>
                                  <span className="text-gray-600">GST Applicable:</span>
                                  <div className={`font-medium px-2 py-1 rounded text-xs mt-1 ${
                                    item.tallyItem.gstApplicable === 'Yes' 
                                      ? 'bg-green-100 text-green-800' 
                                      : 'bg-red-100 text-red-800'
                                  }`}>
                                    {item.tallyItem.gstApplicable}
                                  </div>
                                </div>
                              )}
                              {item.tallyItem.closingBalance && (
                                <div>
                                  <span className="text-gray-600">Closing Balance:</span>
                                  <div className="font-medium text-gray-700 mt-1">
                                    {item.tallyItem.closingBalance}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Enhanced Price List Information with Area Unit Pricing */}
                        {item.tallyItem?.pricelist && item.tallyItem.pricelist.length > 0 && (
                          <div className="mt-4 p-3 bg-green-50 rounded border border-green-200">
                            <div className="text-sm font-medium text-green-800 mb-2 flex items-center gap-1">
                              <FaRupeeSign className="text-green-600" />
                              Tally Price List & Area Unit Pricing
                            </div>
                            <div className="space-y-2 max-h-40 overflow-y-auto">
                              {item.tallyItem.pricelist.map((priceEntry, priceIndex) => (
                                <div key={priceIndex} className="bg-white rounded p-3 border border-green-100">
                                  <div className="space-y-2">
                                    {/* Standard Pricing with GST only */}
                                    <div className="flex justify-between items-center">
                                      {priceEntry.priceLevel && (
                                        <span className="font-medium text-green-700 text-sm">{priceEntry.priceLevel}:</span>
                                      )}
                                      {priceEntry.rates && priceEntry.rates.length > 0 && (
                                        <div className="text-right">
                                          <div className="font-bold text-green-800">
                                            ₹{Math.ceil((priceEntry.rates[0].price || 0) * 1.18).toLocaleString('en-IN')} per {priceEntry.rates[0].unit} 
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    
                                    {/* Area Unit Pricing - show for all items with coverage area */}
                                    {item.tallyItem?.parameter?.coverageArea && priceEntry.rates && priceEntry.rates.length > 0 && (
                                      <div className="bg-purple-50 p-2 rounded border border-purple-200">
                                        <div className="text-xs font-medium text-purple-700 mb-1">
                                          Area Unit Pricing ({item.tallyItem.parameter.coverageAreaUnit || 'sqft'})
                                        </div>
                                        <div className="flex justify-between text-xs">
                                          <div>
                                            <div className="text-purple-600">
                                              Coverage: {item.tallyItem.parameter.coverageArea} {item.tallyItem.parameter.coverageAreaUnit || 'sqft'}/box
                                            </div>
                                            {item.tallyItem.parameter.piecesPerBox && (
                                              <div className="text-purple-600">
                                                Pieces: {item.tallyItem.parameter.piecesPerBox} pcs/box
                                              </div>
                                            )}
                                          </div>
                                          <div className="text-right">
                                            <div className="font-bold text-purple-800">
                                              ₹{Math.ceil(((priceEntry.rates[0].price || 0) * 1.18) / item.tallyItem.parameter.coverageArea).toLocaleString('en-IN')}/{item.tallyItem.parameter.coverageAreaUnit || 'sqft'} 
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  
                                  {priceEntry.date && (
                                    <div className="text-green-600 text-xs italic mt-2">
                                      {new Date(priceEntry.date).toLocaleDateString('en-IN') || priceEntry.date}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                      <div className="flex items-start gap-3">
                        <svg className="w-5 h-5 text-yellow-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
                        </svg>
                        <div>
                          <h5 className="font-medium text-yellow-800">No Items Selected</h5>
                          <p className="text-sm text-yellow-700 mt-1">
                            This choice does not have any items selected.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Payment Information */}
              {viewingChoice.paymentRemark && (
                <div className="border-b border-gray-200 pb-4">
                  <h4 className="text-lg font-semibold text-gray-700 mb-3">Payment Information</h4>
                  <div>
                    <span className="text-sm text-gray-500">Payment Remark:</span>
                    <div className="mt-1 p-3 bg-blue-50 border border-blue-200 rounded">
                      <div className="text-sm text-blue-800">{viewingChoice.paymentRemark}</div>
                    </div>
                  </div>
                </div>
              )}

              {/* Audit Trail */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-700 mb-3">Audit Trail</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <span className="text-sm text-gray-500">Created:</span>
                    <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded">
                      <div className="text-sm text-gray-700">
                        {new Date(viewingChoice.createdAt).toLocaleString()}
                      </div>
                      <div className="text-xs text-gray-500 mt-1">
                        by {viewingChoice.createdBy?.name || 'Unknown'}
                      </div>
                    </div>
                  </div>
                  <div>
                    <span className="text-sm text-gray-500">Last Updated:</span>
                    <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded">
                      <div className="text-sm text-gray-700">
                        {viewingChoice.updatedAt ? new Date(viewingChoice.updatedAt).toLocaleString() : 'Never'}
                      </div>
                      <div className="text-xs text-gray-500 mt-1">
                        by {viewingChoice.updatedBy?.name || 'None'}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="px-6 py-4 border-t border-gray-200 flex justify-between">
              <button
                type="button"
                onClick={() => {
                  setShowViewModal(false);
                  setViewingChoice(null);
                  openStatusModal(viewingChoice);
                }}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 flex items-center gap-2"
              >
                <FaTag />
                Update Status
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowViewModal(false);
                  setViewingChoice(null);
                }}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded-lg hover:bg-gray-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* QR Scanner Modal */}
      {showQRScanner && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-lg w-full">
            <div className="p-6 border-b border-gray-200">
              <div className="flex justify-between items-center">
                <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
                  <FaCamera className="text-blue-600" />
                  Scan QR Code
                </h2>
                <button
                  onClick={stopQRScanner}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <FaTimes />
                </button>
              </div>
            </div>
            
            {/* Add Camera Selection */}
            <div className="px-6 py-3 border-b border-gray-100 bg-gray-50">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Camera:
              </label>
              <select
                value={selectedCameraId}
                onChange={(e) => {
                  const newCamera = e.target.value;
                  setSelectedCameraId(newCamera);
                  // Update facing mode based on camera label if available
                  const selectedCamera = availableCameras.find(cam => cam.id === newCamera);
                  if (selectedCamera) {
                    const label = selectedCamera.label.toLowerCase();
                    setCameraFacingMode(
                      label.includes('back') || label.includes('rear') ? 'environment' : 'user'
                    );
                  }
                }}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                {availableCameras.map((camera) => (
                  <option key={camera.id} value={camera.id}>
                    {camera.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="p-6">
              <div className="relative rounded-lg overflow-hidden bg-black">
                <QRScanner
                  onScan={handleQRScan}
                  cameraId={selectedCameraId}
                  onCameraError={handleQRError}
                  onLoading={handleCameraLoad}
                />
                
                {qrScannerLoading && (
                  <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mb-4"></div>
                    <p className="text-white text-center font-medium">
                      Initializing Camera...
                    </p>
                  </div>
                )}
              </div>
              
              <p className="text-sm text-gray-600 text-center mt-4">
                Position the QR code within the frame to scan automatically
              </p>
              
              <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                <p className="text-xs text-blue-700 text-center">
                  💡 Make sure to allow camera permissions when prompted by your browser
                </p>
              </div>
              
              <div className="mt-4 text-center">
                <button
                  onClick={stopQRScanner}
                  className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm"
                >
                  Stop Scanning
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
{/* Item Details Modal */}
{showItemDetailsModal && selectedItemForDetails && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[70vh] overflow-y-auto">
      <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
        <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          <FaEye className="text-indigo-600" />
          Item Details - {safeRender(selectedItemForDetails?.Name || selectedItemForDetails?.name, 'Unknown Item')}
        </h3>
        <button
          onClick={() => {
            setShowItemDetailsModal(false);
            setSelectedItemForDetails(null);
          }}
          className="text-gray-400 hover:text-gray-600 p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <FaTimes size={20} />
        </button>
      </div>
      
      <div className="p-6 space-y-6">
        {/* Safety check for selectedItemForDetails */}
        {!selectedItemForDetails ? (
          <div className="text-center py-8">
            <p className="text-gray-500">No item data available</p>
          </div>
        ) : (
          <>
            {/* Basic Information */}
            <div className="border-b border-gray-200 pb-4">
              <h4 className="text-lg font-semibold text-gray-700 mb-3">Basic Information</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex justify-between">
                  <span className="text-sm text-gray-500">ID:</span>
                  <div className="font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded text-sm">
                    {safeRender(selectedItemForDetails.id)}
                  </div>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-500">GUID:</span>
                  <div className="font-mono text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                    {safeRender(selectedItemForDetails.GUID)}
                  </div>
                </div>
                <div className="col-span-full">
                  <span className="text-sm text-gray-500">Name:</span>
                  <div className="font-medium text-gray-900 mt-1 p-2 bg-gray-50 rounded">
                    {safeRender(selectedItemForDetails.Name || selectedItemForDetails.name)}
                  </div>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-500">Category:</span>
                  <div className="font-medium bg-blue-50 text-blue-800 px-2 py-1 rounded text-sm">
                    {safeRender(selectedItemForDetails.category)}
                  </div>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm text-gray-500">Parent:</span>
                  <div className="font-medium text-gray-700">
                    {safeRender(selectedItemForDetails.parent, 'None')}
                  </div>
                </div>
              </div>
            </div>

        {/* Tax Information */}
        <div className="border-b border-gray-200 pb-4">
          <h4 className="text-lg font-semibold text-gray-700 mb-3">Tax Information</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">HSN Code:</span>
              <div className="font-medium bg-yellow-50 text-yellow-800 px-2 py-1 rounded text-sm">
                {safeRender(selectedItemForDetails.hsnCode)}
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">GST Applicable:</span>
              <div className={`font-medium px-2 py-1 rounded text-sm ${
                selectedItemForDetails.gstApplicable === 'Yes' 
                  ? 'bg-green-50 text-green-800' 
                  : 'bg-red-50 text-red-800'
              }`}>
                {safeRender(selectedItemForDetails.gstApplicable)}
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Integrated Tax:</span>
              <div className="font-medium text-gray-700">{safeRender(selectedItemForDetails.integratedTax, '0')}%</div>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Central Tax:</span>
              <div className="font-medium text-gray-700">{safeRender(selectedItemForDetails.centralTax, '0')}%</div>
            </div>
          </div>
        </div>

        {/* Units Information */}
        <div className="border-b border-gray-200 pb-4">
          <h4 className="text-lg font-semibold text-gray-700 mb-3">Units Information</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Base Units:</span>
              <div className="font-medium bg-purple-50 text-purple-800 px-2 py-1 rounded text-sm">
                {safeRender(selectedItemForDetails.baseUnits)}
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Additional Units:</span>
              <div className="font-medium text-gray-700">
                {safeRender(selectedItemForDetails.additionalUnits, 'None')}
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Closing Balance:</span>
              <div className="font-medium text-gray-700">
                {safeRender(selectedItemForDetails.closingBalance, '0')}
              </div>
            </div>
          </div>
        </div>

        {/* Product Information */}
        <div className="border-b border-gray-200 pb-4">
          <h4 className="text-lg font-semibold text-gray-700 mb-3">Product Information</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Part Number:</span>
              <div className="font-medium text-gray-700 font-mono text-sm">
                {safeRender(selectedItemForDetails.partNo, 'Not specified')}
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Alter ID:</span>
              <div className="font-medium text-gray-700">
                {safeRender(selectedItemForDetails.alterID)}
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-sm text-gray-500">Section:</span>
              <div className="font-medium text-gray-700">
                {safeRender(selectedItemForDetails.section, 'Not assigned')}
              </div>
            </div>
            <div className="col-span-full">
              <span className="text-sm text-gray-500">Remote Alt GUID:</span>
              <div className="font-mono text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded mt-1 break-all">
                {safeRender(selectedItemForDetails.remoteAltGUID)}
              </div>
            </div>
          </div>
        </div>

        {/* Assignments */}
        <div className="border-b border-gray-200 pb-4">
          <h4 className="text-lg font-semibold text-gray-700 mb-3">Assignments</h4>
          <div className="grid grid-cols-1 gap-4">
            <div>
              <span className="text-sm text-gray-500">Parameter:</span>
              {selectedItemForDetails.parameter ? (
                <div className="mt-1 p-3 bg-green-50 border border-green-200 rounded">
                  <div className="font-medium text-green-800">{safeRender(selectedItemForDetails.parameter.name)}</div>
                  <div className="text-xs text-green-600">
                    Type: {selectedItemForDetails.parameter.calculationType === 'pcsPerBox' ? 'Pieces per Box' : 'Simple Pieces'}
                  </div>
                  {selectedItemForDetails.parameter.calculationType === 'pcsPerBox' && (
                    <div className="text-xs text-green-600 mt-1">
                      Size: {safeRender(selectedItemForDetails.parameter.width, '0')}×{safeRender(selectedItemForDetails.parameter.height, '0')} | 
                      Box: {safeRender(selectedItemForDetails.parameter.piecesPerBox, '0')} pcs | 
                      Coverage: {safeRender(selectedItemForDetails.parameter.coverageArea, '0')} {safeRender(selectedItemForDetails.parameter.coverageAreaUnit, 'sqft')}
                    </div>
                  )}
                </div>
              ) : (
                <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded text-gray-500 text-sm">
                  No parameter assigned
                </div>
              )}
            </div>
            <div>
              <span className="text-sm text-gray-500">Brand:</span>
              {selectedItemForDetails.brand ? (
                <div className="mt-1 p-3 bg-blue-50 border border-blue-200 rounded">
                  <div className="font-medium text-blue-800">{safeRender(selectedItemForDetails.brand.name)}</div>
                </div>
              ) : (
                <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded text-gray-500 text-sm">
                  No brand assigned
                </div>
              )}
            </div>
            <div>
              <span className="text-sm text-gray-500">Series:</span>
              <div className="mt-1 p-3 bg-purple-50 border border-purple-200 rounded">
                <div className="font-medium text-purple-800">
                  {safeRender(selectedItemForDetails.series, 'RS')} - {(() => {
                    const seriesOptions = [
                      { value: 'RS', label: 'Regular Stock (RS)' },
                      { value: 'AO', label: 'Against Order (AO)' },
                      { value: 'SC', label: 'Stock Clearance (SC)' },
                      { value: 'DC', label: 'Discontinued (DC)' },
                      { value: 'ITF', label: 'Item to Focus (ITF)' },
                      { value: 'OT', label: 'One Time (OT)' }
                    ];
                    const series = selectedItemForDetails.series || 'RS';
                    return seriesOptions.find(opt => opt.value === series)?.label || 'Regular Stock (RS)';
                  })()}
                </div>
              </div>
            </div>
            <div>
              <span className="text-sm text-gray-500">Assigned Category:</span>
              {selectedItemForDetails.assigncategory ? (
                <div className="mt-1 p-3 bg-orange-50 border border-orange-200 rounded">
                  <div className="font-medium text-orange-800">{safeRender(selectedItemForDetails.assigncategory.name)}</div>
                </div>
              ) : (
                <div className="mt-1 p-3 bg-gray-50 border border-gray-200 rounded text-gray-500 text-sm">
                  No assigned category
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Stock Information */}
        {selectedItemForDetails.stockSummary && selectedItemForDetails.stockSummary.length > 0 && (
          <div className="border-b border-gray-200 pb-4">
            <h4 className="text-lg font-semibold text-gray-700 mb-3">Stock Information</h4>
            <div className="space-y-2">
              {selectedItemForDetails.stockSummary.map((stockItem, index) => (
                <div key={index} className="p-3 bg-gray-50 rounded border border-gray-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div>
                      <span className="text-xs text-gray-500">Location:</span>
                      <div className="font-medium text-gray-700">{safeRender(stockItem.location?.Name, 'Main Warehouse')}</div>
                    </div>
                    <div>
                      <span className="text-xs text-gray-500">Quantity:</span>
                      <div className="font-medium text-gray-700">{safeRender(stockItem.quantity, '0')} {safeRender(selectedItemForDetails.baseUnits, 'units')}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Enhanced Price List with Area Unit Pricing */}
        {selectedItemForDetails.pricelist && selectedItemForDetails.pricelist.length > 0 && (
          <div className="border-b border-gray-200 pb-4">
            <h4 className="text-lg font-semibold text-gray-700 mb-3">Price List & Area Unit Pricing</h4>
            <div className="space-y-3">
              {selectedItemForDetails.pricelist.map((priceEntry, index) => (
                <div key={index} className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-lg border border-green-200">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="font-semibold text-green-800 text-base">
                        {safeRender(priceEntry.priceLevel, `Price Level ${index + 1}`)}
                      </div>
                      {priceEntry.rates && priceEntry.rates.length > 0 && (
                        <div className="mt-2 space-y-3">
                          {priceEntry.rates.map((rate, rateIndex) => (
                            <div key={rateIndex} className="space-y-2">
                              {/* Standard Pricing with GST only */}
                              <div className="flex justify-between items-center">
                                <span className="text-sm text-gray-600">
                                  {rate.quantity ? `${safeRender(rate.quantity)} ${safeRender(selectedItemForDetails.baseUnits, 'PCS')}` : 'Standard Rate'}
                                </span>
                                <div className="text-right">
                                  <div className="font-bold text-green-700 text-lg">
                                    ₹{Math.ceil((parseFloat(safeRender(rate.price, '0')) || 0) * 1.18).toLocaleString('en-IN')}{rate.unit ? `/${rate.unit}` : ''} 
                                  </div>
                                </div>
                              </div>
                              
                              {/* Area unit pricing - show for all items with coverage area */}
                              {selectedItemForDetails.parameter?.coverageArea && (
                                <div className="bg-purple-50 p-3 rounded-lg border border-purple-200">
                                  <div className="text-sm font-semibold text-purple-800 mb-2">
                                    Area Unit Pricing ({selectedItemForDetails.parameter.coverageAreaUnit || 'sqft'})
                                  </div>
                                  <div className="grid grid-cols-2 gap-4 text-sm">
                                    <div>
                                      <span className="text-purple-600">Coverage per box:</span>
                                      <div className="font-medium text-purple-800">
                                        {selectedItemForDetails.parameter.coverageArea} {selectedItemForDetails.parameter.coverageAreaUnit || 'sqft'}
                                      </div>
                                    </div>
                                    {selectedItemForDetails.parameter?.piecesPerBox && (
                                      <div>
                                        <span className="text-purple-600">Pieces per box:</span>
                                        <div className="font-medium text-purple-800">
                                          {selectedItemForDetails.parameter.piecesPerBox} pcs
                                        </div>
                                      </div>
                                    )}
                                    <div className="col-span-2">
                                      <span className="text-purple-600">Price per {selectedItemForDetails.parameter.coverageAreaUnit || 'sqft'} :</span>
                                      <div className="font-bold text-purple-800 text-lg">
                                        ₹{Math.ceil(((parseFloat(rate.price) || 0) * 1.18) / selectedItemForDetails.parameter.coverageArea).toLocaleString('en-IN')}
                                      </div>
                                    </div>
                                  </div>
                                  
                                  {/* Additional calculation info for pcsPerBox items */}
                                  {selectedItemForDetails.parameter?.calculationType === 'pcsPerBox' && selectedItemForDetails.parameter?.piecesPerBox && (
                                    <div className="mt-2 pt-2 border-t border-purple-200">
                                      <div className="text-xs text-purple-600">
                                        <div>• Price per piece : ₹{Math.ceil(((parseFloat(rate.price) || 0) * 1.18) / selectedItemForDetails.parameter.piecesPerBox).toLocaleString('en-IN')}</div>
                                        <div>• Coverage per piece: {(selectedItemForDetails.parameter.coverageArea / selectedItemForDetails.parameter.piecesPerBox).toFixed(2)} {selectedItemForDetails.parameter.coverageAreaUnit || 'sqft'}</div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                      {priceEntry.date && (
                        <div className="text-xs text-gray-500 mt-2">
                          Effective from: {new Date(priceEntry.date).toLocaleDateString('en-IN')}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Stock Summary by Location */}
        {selectedItemForDetails.stockSummary && selectedItemForDetails.stockSummary.length > 0 ? (
          <div className="border-b border-gray-200 pb-4">
            <h4 className="text-lg font-semibold text-gray-700 mb-3">Stock Summary by Location</h4>
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Location
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Base Stock
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Additional Stock
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {selectedItemForDetails.stockSummary.map((stock, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium text-gray-900">
                            {stock.location.Name || 'Main Warehouse'}
                          </div>
                          <div className="text-sm text-gray-500">
                            {stock.stocks?.base?.unit || stock.stocks?.additional?.unit || 'PCS'}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            <span className="font-medium">
                              {(stock.stocks?.base?.quantity || 0).toLocaleString('en-IN', { 
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2 
                              })}
                            </span>
                            <span className="text-gray-500 ml-1">
                              {stock.stocks?.base?.unit || 'PCS'}
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            <span className="font-medium">
                              {(stock.stocks?.additional?.quantity || 0).toLocaleString('en-IN', { 
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2 
                              })}
                            </span>
                            <span className="text-gray-500 ml-1">
                              {stock.stocks?.additional?.unit || 'PCS'}
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Additional Item Info */}
            <div className="bg-gray-50 p-4 rounded-lg mt-4">
              <h5 className="text-md font-semibold text-gray-800 mb-3">Additional Information</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="font-medium text-gray-600">Item ID:</span>
                  <span className="ml-2 text-gray-900">{selectedItemForDetails.id || 'N/A'}</span>
                </div>
                <div>
                  <span className="font-medium text-gray-600">GUID:</span>
                  <span className="ml-2 text-gray-900 font-mono text-xs">{selectedItemForDetails.GUID || 'N/A'}</span>
                </div>
                <div>
                  <span className="font-medium text-gray-600">Base Units:</span>
                  <span className="ml-2 text-gray-900">{selectedItemForDetails.baseUnits || 'N/A'}</span>
                </div>
                <div>
                  <span className="font-medium text-gray-600">Additional Units:</span>
                  <span className="ml-2 text-gray-900">{selectedItemForDetails.additionalUnits || 'N/A'}</span>
                </div>
                {selectedItemForDetails.hsnCode && (
                  <div>
                    <span className="font-medium text-gray-600">HSN Code:</span>
                    <span className="ml-2 text-gray-900">{selectedItemForDetails.hsnCode}</span>
                  </div>
                )}
                <div>
                  <span className="font-medium text-gray-600">Last Updated:</span>
                  <span className="ml-2 text-gray-900">
                    {selectedItemForDetails.updatedAt ? 
                      new Date(selectedItemForDetails.updatedAt).toLocaleDateString('en-IN', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      }) : 'N/A'
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="border-b border-gray-200 pb-4">
            <h4 className="text-lg font-semibold text-gray-700 mb-3">Stock Summary</h4>
            <div className="text-center py-12">
              <FaExclamationTriangle className="h-16 w-16 text-gray-400 mx-auto mb-4" />
              <h4 className="text-lg font-medium text-gray-900 mb-2">No Stock Summary Available</h4>
              <p className="text-gray-600 mb-4">
                Stock summary data has not been synced for this item yet.
              </p>
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-200 text-left max-w-md mx-auto">
                <h5 className="font-medium text-blue-800 mb-2">To view stock summary:</h5>
                <ul className="text-sm text-blue-700 space-y-1">
                  <li>• Ensure Tally is connected and active</li>
                  <li>• Run a "Stock Summary" sync from the sync management</li>
                  <li>• Wait for the sync to complete</li>
                  <li>• Refresh this page to see updated data</li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
          {showItemModal && (
            <button
              onClick={() => {
                handleItemSelect(selectedItemForDetails);
                setShowItemDetailsModal(false);
                setSelectedItemForDetails(null);
              }}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium flex items-center gap-2"
            >
              <FaCheck />
              Select This Item
            </button>
          )}
          <button
            onClick={() => {
              setShowItemDetailsModal(false);
              setSelectedItemForDetails(null);
            }}
            className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
        </>
        )}
      </div>
    </div>
  </div>
)}

     
      {/* Create Guest Modal */}
      {showCreateGuestModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full h-full flex flex-col">
            {/* Header */}
            <div className="bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 text-white p-6 shadow-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => {
                      setShowCreateGuestModal(false);
                      setNewGuestForm({
                        guestName: '',
                        phoneNo: '',
                        email: '',
                        station: '',
                        reference: '',
                        salesperson: { value: '', label: '' }
                      });
                    }}
                    className="p-3 bg-white bg-opacity-20 rounded-xl hover:bg-opacity-30 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    title="Go Back"
                  >
                    <FaArrowLeft size={20} />
                  </button>
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-white bg-opacity-20 rounded-xl">
                      <FaUser size={28} />
                    </div>
                    <div>
                      <h2 className="text-3xl font-bold">Create New Guest</h2>
                      <p className="text-green-100 mt-1">Add a new guest to your database</p>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="bg-white bg-opacity-20 px-4 py-2 rounded-xl">
                    <span className="text-sm font-medium">Guest Registration</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Form Content */}
            <div className="flex-1 overflow-y-auto bg-gray-50 p-8">
              <div className="w-full mx-auto">
                <form onSubmit={handleCreateGuest} className="space-y-8">
                  {/* Personal Information Section */}
                  <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-200 shadow-sm">
                    <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
                      <FaUser className="text-green-600" />
                      Personal Information
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                          Guest Name <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          required
                          value={newGuestForm.guestName}
                          onChange={(e) => setNewGuestForm(prev => ({ ...prev, guestName: e.target.value.toUpperCase() }))}
                          className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 text-base"
                          placeholder="Enter guest name"
                          style={{ textTransform: 'uppercase' }}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                          Phone Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          required
                          maxLength={10}
                          value={newGuestForm.phoneNo}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setNewGuestForm(prev => ({ ...prev, phoneNo: value }));
                          }}
                          className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 text-base"
                          placeholder="Enter 10-digit phone number"
                        />
                        {newGuestForm.phoneNo && newGuestForm.phoneNo.length !== 10 && (
                          <p className="text-red-500 text-sm mt-1">Phone number must be 10 digits</p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                          Secondary Phone Number (Optional)
                        </label>
                        <input
                          type="tel"
                          maxLength={10}
                          value={newGuestForm.secondaryPhoneNo}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setNewGuestForm(prev => ({ ...prev, secondaryPhoneNo: value }));
                          }}
                          className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 text-base"
                          placeholder="Enter 10-digit secondary phone number (optional)"
                        />
                        {newGuestForm.secondaryPhoneNo && newGuestForm.secondaryPhoneNo.length > 0 && newGuestForm.secondaryPhoneNo.length !== 10 && (
                          <p className="text-red-500 text-sm mt-1">Secondary phone number must be 10 digits</p>
                        )}
                        {newGuestForm.secondaryPhoneNo && newGuestForm.phoneNo && newGuestForm.secondaryPhoneNo === newGuestForm.phoneNo && (
                          <p className="text-red-500 text-sm mt-1">Secondary phone number must be different from primary phone number</p>
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-3">
                          Email
                        </label>
                        <input
                          type="email"
                          value={newGuestForm.email}
                          onChange={(e) => setNewGuestForm(prev => ({ ...prev, email: e.target.value }))}
                          className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 text-base"
                          placeholder="Enter email address (optional)"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Station <span className="text-red-500">*</span>
                    </label>
                    <Select
                      value={newGuestForm.station ? stationOptions.find(option => option.value === newGuestForm.station) : null}
                      onChange={(selectedOption) => setNewGuestForm(prev => ({ ...prev, station: selectedOption ? selectedOption.value : '' }))}
                      options={stationOptions}
                      placeholder="Select station"
                      styles={customSelectStyles}
                      isSearchable
                      isClearable
                      isRequired
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Reference <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      value={newGuestForm.reference}
                      onChange={(e) => setNewGuestForm(prev => ({ ...prev, reference: e.target.value.toUpperCase() }))}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                      placeholder="Enter reference"
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Salesperson <span className="text-red-500">*</span>
                    </label>
                    <Select
                      value={newGuestForm.salesperson}
                      onChange={(selectedOption) => setNewGuestForm(prev => ({ ...prev, salesperson: selectedOption }))}
                      options={salespersons.map(sp => ({ value: sp._id, label: sp.name }))}
                      placeholder="Select salesperson"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      isSearchable
                      isClearable
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          padding: '8px',
                          border: '1px solid #d1d5db',
                          borderRadius: '8px',
                          '&:hover': { border: '1px solid #d1d5db' },
                          '&:focus-within': { 
                            border: '2px solid #10b981',
                            boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.1)'
                          }
                        })
                      }}
                    />
                  </div>

                {/* Submit Button */}
                <div className="flex justify-end space-x-4 pt-6">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCreateGuestModal(false);
                      setNewGuestForm({
                        guestName: '',
                        phoneNo: '',
                        station: '',
                        reference: '',
                        salesperson: { value: '', label: '' }
                      });
                    }}
                    className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
                  >
                    Create Guest
                  </button>
                  </div>
              </form>
                </div>
                </div>
              </div>
            </div>
      )}

      {/* Create Reference Modal */}
      {showCreateReferenceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-y-auto mx-4">
            <div className="p-8">
              {/* Header */}
              <div className="flex justify-between items-center mb-8">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl">
                    <FaUsers size={24} />
                  </div>
                  <div>
                    <h3 className="text-3xl font-bold text-gray-800">Create New Reference</h3>
                    <p className="text-gray-600 mt-1">Add a new reference to your database</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => {
                      setShowCreateReferenceModal(false);
                      setSelectedStation(null);
                      setSelectedReferenceType(null);
                      setNewReferenceForm({
                        name: '',
                        phoneNumber: '',
                        classification: '',
                        type: '',
                        station: ''
                      });
                    }}
                    className="p-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-xl hover:from-gray-600 hover:to-gray-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    title="Close"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>

              <form onSubmit={handleCreateReference} className="space-y-8">
                {/* Basic Information Section */}
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border border-purple-200 shadow-sm">
                  <h4 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                    <FaUser className="text-purple-600" />
                    Basic Information
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-3">
                        Reference Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={newReferenceForm.name}
                        onChange={(e) => setNewReferenceForm(prev => ({ ...prev, name: e.target.value.toUpperCase() }))}
                        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 text-base"
                        placeholder="Enter reference name"
                        style={{ textTransform: 'uppercase' }}
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-3">
                        Phone Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        value={newReferenceForm.phoneNumber}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, '');
                          setNewReferenceForm(prev => ({ ...prev, phoneNumber: value }));
                        }}
                        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 text-base"
                        placeholder="Enter 10-digit phone number"
                        maxLength={10}
                        required
                      />
                      {newReferenceForm.phoneNumber && newReferenceForm.phoneNumber.length !== 10 && (
                        <p className="text-red-500 text-sm mt-1">Phone number must be 10 digits</p>
                      )}
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-3">
                        Secondary Phone Number (Optional)
                      </label>
                      <input
                        type="tel"
                        value={newReferenceForm.secondaryPhoneNumber}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, '');
                          setNewReferenceForm(prev => ({ ...prev, secondaryPhoneNumber: value }));
                        }}
                        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 text-base"
                        placeholder="Enter 10-digit secondary phone number (optional)"
                        maxLength={10}
                      />
                      {newReferenceForm.secondaryPhoneNumber && newReferenceForm.secondaryPhoneNumber.length > 0 && newReferenceForm.secondaryPhoneNumber.length !== 10 && (
                        <p className="text-red-500 text-sm mt-1">Secondary phone number must be 10 digits</p>
                      )}
                      {newReferenceForm.secondaryPhoneNumber && newReferenceForm.phoneNumber && newReferenceForm.secondaryPhoneNumber === newReferenceForm.phoneNumber && (
                        <p className="text-red-500 text-sm mt-1">Secondary phone number must be different from primary phone number</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Location & Classification Section */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-200 shadow-sm">
                  <h4 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                    <FaUsers className="text-blue-600" />
                    Location & Classification
                  </h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-3">
                        Station <span className="text-red-500">*</span>
                      </label>
                      <Select
                        value={selectedStation}
                        onChange={(option) => {
                          setSelectedStation(option);
                          setNewReferenceForm(prev => ({ ...prev, station: option ? option.value : '' }));
                        }}
                        options={stationOptions}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select station..."
                        isSearchable
                        isClearable
                        menuPlacement="auto"
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            minHeight: '50px',
                          }),
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: '50px',
                            borderRadius: '0.75rem',
                            borderWidth: '2px',
                            borderColor: state.isFocused ? '#8b5cf6' : '#d1d5db',
                            boxShadow: state.isFocused ? '0 0 0 2px rgba(139, 92, 246, 0.2)' : 'none',
                            '&:hover': {
                              borderColor: '#8b5cf6',
                            },
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                            borderRadius: '0.75rem',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected ? '#8b5cf6' : state.isFocused ? '#f3f4f6' : 'white',
                            color: state.isSelected ? 'white' : '#374151',
                            '&:hover': {
                              backgroundColor: state.isSelected ? '#8b5cf6' : '#f3f4f6',
                            },
                          }),
                        }}
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-3">
                        Classification <span className="text-red-500">*</span>
                      </label>
                      <Select
                        onChange={(option) => {
                          setNewReferenceForm(prev => ({ ...prev, classification: option ? option.value : '' }));
                        }}
                        options={[
                          { value: 'A', label: 'A' },
                          { value: 'B', label: 'B' },
                          { value: 'C', label: 'C' },
                          { value: 'D', label: 'D' },
                          { value: 'E', label: 'E' }
                        ]}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select classification..."
                        isSearchable
                        isClearable
                        menuPlacement="auto"
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            minHeight: '50px',
                          }),
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: '50px',
                            borderRadius: '0.75rem',
                            borderWidth: '2px',
                            borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
                            boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.2)' : 'none',
                            '&:hover': {
                              borderColor: '#3b82f6',
                            },
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                            borderRadius: '0.75rem',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f3f4f6' : 'white',
                            color: state.isSelected ? 'white' : '#374151',
                            '&:hover': {
                              backgroundColor: state.isSelected ? '#3b82f6' : '#f3f4f6',
                            },
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Professional Information Section */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-200 shadow-sm">
                  <h4 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
                    <FaUsers className="text-green-600" />
                    Professional Information
                  </h4>
                  <div className="grid grid-cols-1 gap-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-3">
                        Reference Type <span className="text-red-500">*</span>
                      </label>
                      <Select
                        value={selectedReferenceType}
                        onChange={(option) => {
                          setSelectedReferenceType(option);
                          setNewReferenceForm(prev => ({ ...prev, type: option ? option.value : '' }));
                        }}
                        options={[
                          { value: 'Interior', label: 'Interior' },
                          { value: 'Designer', label: 'Designer' },
                          { value: 'Architect', label: 'Architect' }
                        ]}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select reference type..."
                        isSearchable
                        isClearable
                        menuPlacement="auto"
                        formatOptionLabel={(option) => (
                          <div className="flex items-center justify-between">
                            <span className="font-medium">{option.label}</span>
                            {option.description && (
                              <span className="text-sm text-gray-500">{option.description}</span>
                            )}
                          </div>
                        )}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            minHeight: '50px',
                          }),
                          control: (provided, state) => ({
                            ...provided,
                            minHeight: '50px',
                            borderRadius: '0.75rem',
                            borderWidth: '2px',
                            borderColor: state.isFocused ? '#10b981' : '#d1d5db',
                            boxShadow: state.isFocused ? '0 0 0 2px rgba(16, 185, 129, 0.2)' : 'none',
                            '&:hover': {
                              borderColor: '#10b981',
                            },
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                            borderRadius: '0.75rem',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                          }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isSelected ? '#10b981' : state.isFocused ? '#f3f4f6' : 'white',
                            color: state.isSelected ? 'white' : '#374151',
                            padding: '12px 16px',
                            '&:hover': {
                              backgroundColor: state.isSelected ? '#10b981' : '#f3f4f6',
                            },
                          }),
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end space-x-4 pt-6">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCreateReferenceModal(false);
                      setSelectedStation(null);
                      setSelectedReferenceType(null);
                      setNewReferenceForm({
                        name: '',
                        phoneNumber: '',
                        classification: '',
                        type: '',
                        station: ''
                      });
                    }}
                    className="px-8 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-xl hover:from-gray-600 hover:to-gray-700 transition-all duration-200 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2"
                  >
                    <FaTimes size={16} />
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-xl hover:from-purple-600 hover:to-pink-600 transition-all duration-200 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-2"
                  >
                    <FaPlus size={16} />
                    Create Reference
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Customer Selection Modal */}
      {showCustomerModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white p-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold flex items-center gap-2">
                  <FaUserTie />
                  Select Customer
                </h2>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => setShowCreateCustomerModal(true)}
                    className="px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-lg transition-colors flex items-center gap-2 text-sm font-semibold"
                  >
                    <FaPlus size={14} />
                    Create New
                  </button>
                  <button
                    onClick={() => setShowCustomerModal(false)}
                    className="text-white hover:text-gray-200 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
                  >
                    <FaTimes size={24} />
                  </button>
                </div>
              </div>
              <div className="mt-4">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search customers..."
                    value={customerSearch}
                    onChange={(e) => {
                      setCustomerSearch(e.target.value);
                      setCustomerPage(1);
                    }}
                    className="w-full px-4 py-3 pl-10 text-gray-800 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                </div>
              </div>
            </div>
            
            <div className="p-6 overflow-y-auto max-h-[60vh]">
              {loadingCustomers ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
                </div>
              ) : customers.length === 0 ? (
                <div className="text-center py-8">
                  <FaUserTie className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-500">No customers found</p>
                  <button
                    onClick={() => setShowCreateCustomerModal(true)}
                    className="mt-4 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2 mx-auto"
                  >
                    <FaPlus size={14} />
                    Create New Customer
                  </button>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {customers.map((customer) => (
                    <div
                      key={customer._id}
                      onClick={() => handleCustomerSelect(customer)}
                      className="p-4 border border-gray-200 rounded-lg hover:border-green-500 hover:bg-green-50 cursor-pointer transition-colors"
                    >
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-green-100 text-green-600 rounded-lg">
                          <FaUserTie size={20} />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-800">{customer.name}</h4>
                          <p className="text-sm text-gray-600">📞 {customer.phone}</p>
                          {customer.email && (
                            <p className="text-sm text-gray-500">✉️ {customer.email}</p>
                          )}
                          {customer.gstNo && (
                            <p className="text-sm text-gray-500">GST: {customer.gstNo}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              {totalCustomerPages > 1 && (
                <div className="flex justify-center mt-6">
                  <button
                    onClick={() => {
                      setCustomerPage(prev => prev + 1);
                      loadCustomers(customerPage + 1, customerSearch);
                    }}
                    disabled={customerPage >= totalCustomerPages}
                    className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Dealer Selection Modal */}
      {showDealerModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="bg-gradient-to-r from-orange-600 to-red-600 text-white p-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold flex items-center gap-2">
                  <FaBuilding />
                  Select Dealer
                </h2>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => setShowCreateDealerModal(true)}
                    className="px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 text-white rounded-lg transition-colors flex items-center gap-2 text-sm font-semibold"
                  >
                    <FaPlus size={14} />
                    Create New
                  </button>
                  <button
                    onClick={() => setShowDealerModal(false)}
                    className="text-white hover:text-gray-200 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
                  >
                    <FaTimes size={24} />
                  </button>
                </div>
              </div>
              <div className="mt-4">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search dealers..."
                    value={dealerSearch}
                    onChange={(e) => {
                      setDealerSearch(e.target.value);
                      setDealerPage(1);
                    }}
                    className="w-full px-4 py-3 pl-10 text-gray-800 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                </div>
              </div>
            </div>
            
            <div className="p-6 overflow-y-auto max-h-[60vh]">
              {loadingDealers ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
                </div>
              ) : dealers.length === 0 ? (
                <div className="text-center py-8">
                  <FaBuilding className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-500">No dealers found</p>
                  <button
                    onClick={() => setShowCreateDealerModal(true)}
                    className="mt-4 px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors flex items-center gap-2 mx-auto"
                  >
                    <FaPlus size={14} />
                    Create New Dealer
                  </button>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {dealers.map((dealer) => (
                    <div
                      key={dealer._id}
                      onClick={() => handleDealerSelect(dealer)}
                      className="p-4 border border-gray-200 rounded-lg hover:border-orange-500 hover:bg-orange-50 cursor-pointer transition-colors"
                    >
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-orange-100 text-orange-600 rounded-lg">
                          <FaBuilding size={20} />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-800">{dealer.businessName}</h4>
                          <p className="text-sm text-gray-600">📞 {dealer.phone}</p>
                          {dealer.email && (
                            <p className="text-sm text-gray-500">✉️ {dealer.email}</p>
                          )}
                          {dealer.gstNo && (
                            <p className="text-sm text-gray-500">GST: {dealer.gstNo}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              
              {totalDealerPages > 1 && (
                <div className="flex justify-center mt-6">
                  <button
                    onClick={() => {
                      setDealerPage(prev => prev + 1);
                      loadDealers(dealerPage + 1, dealerSearch);
                    }}
                    disabled={dealerPage >= totalDealerPages}
                    className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    Load More
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Create Customer Modal */}
      {showCreateCustomerModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[60] flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden shadow-2xl">
            <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white p-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold flex items-center gap-2">
                  <FaUserTie />
                  Create New Customer
                </h2>
                <button
                  onClick={() => {
                    setShowCreateCustomerModal(false);
                    setNewCustomerForm({ name: '', phone: '', secondaryPhone: '', email: '', station: '', pinCode: '', panNo: '', gstNo: '', siteAddress: '', deliveryAddress: '', salutation: '', createdBy: user?.user?._id });
                    setIsCustomerPanReadOnly(false);
                    setIsCustomerGstReadOnly(false);
                    setShowCustomerGstPanFields(false);
                  }}
                  className="text-white hover:text-gray-200 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
                >
                  <FaTimes size={24} />
                </button>
              </div>
            </div>
            
            <form onSubmit={handleCreateCustomer} className="p-6 overflow-y-auto max-h-[70vh] space-y-4">
              {/* GST/PAN Verification Buttons or Fields */}
              {!showCustomerGstPanFields ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-sm text-gray-700">GST Verification</label>
                    <button
                      type="button"
                      onClick={() => setShowCustomerGSTVerification(true)}
                      className="px-4 py-2.5 rounded-lg transition-all text-sm flex items-center justify-center space-x-2 shadow-md hover:shadow-lg bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white"
                    >
                      <span>🔍</span>
                      <span>Verify GST Number</span>
                    </button>
                    <p className="text-xs mt-1 text-gray-500">Verify GSTIN and auto-extract PAN</p>
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-sm text-gray-700">PAN Verification</label>
                    <button
                      type="button"
                      onClick={() => setShowCustomerPANVerification(true)}
                      className="px-4 py-2.5 rounded-lg transition-all text-sm flex items-center justify-center space-x-2 shadow-md hover:shadow-lg bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white"
                    >
                      <span>🔍</span>
                      <span>Verify PAN Number</span>
                    </button>
                    <p className="text-xs mt-1 text-gray-500">Verify PAN number independently</p>
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* GST No */}
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-gray-700">
                      GST No {isCustomerGstReadOnly && <span className="text-sm text-blue-600">(Verified) 🔒</span>}
                    </label>
                    <div className="flex space-x-2">
                      <input
                        type="text"
                        value={newCustomerForm.gstNo}
                        onChange={(e) => setNewCustomerForm(prev => ({ ...prev, gstNo: e.target.value.toUpperCase() }))}
                        placeholder="15-digit GST number"
                        maxLength="15"
                        disabled={isCustomerGstReadOnly}
                        className={`border rounded-lg p-2.5 w-full focus:outline-none focus:ring-2 focus:ring-green-500 ${isCustomerGstReadOnly ? 'bg-gray-200 text-gray-600 cursor-not-allowed' : 'bg-white'}`}
                      />
                      <button
                        type="button"
                        onClick={() => setShowCustomerGSTVerification(true)}
                        disabled={isCustomerGstReadOnly}
                        className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap ${isCustomerGstReadOnly ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'}`}
                      >
                        {isCustomerGstReadOnly ? '✅ Verified' : '🔍 Verify'}
                      </button>
                    </div>
                  </div>
                  {/* PAN No */}
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-gray-700">
                      PAN No {isCustomerPanReadOnly && <span className="text-sm text-blue-600">(Auto-extracted) 🔒</span>}
                    </label>
                    <div className="flex space-x-2">
                      <input
                        type="text"
                        value={newCustomerForm.panNo}
                        onChange={(e) => setNewCustomerForm(prev => ({ ...prev, panNo: e.target.value.toUpperCase() }))}
                        placeholder="Enter PAN"
                        maxLength="10"
                        disabled={isCustomerPanReadOnly}
                        className={`border rounded-lg p-2.5 w-full focus:outline-none focus:ring-2 focus:ring-green-500 ${isCustomerPanReadOnly ? 'bg-gray-200 text-gray-600 cursor-not-allowed' : 'bg-white'}`}
                      />
                      <button
                        type="button"
                        onClick={() => setShowCustomerPANVerification(true)}
                        disabled={isCustomerPanReadOnly}
                        className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap ${isCustomerPanReadOnly ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 text-white'}`}
                      >
                        {isCustomerPanReadOnly ? '✅ From GST' : '🔍 Verify'}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Salutation & Name */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Salutation</label>
                  <select
                    value={newCustomerForm.salutation}
                    onChange={(e) => setNewCustomerForm(prev => ({ ...prev, salutation: e.target.value }))}
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                  >
                    <option value="">Select</option>
                    <option value="Mr.">Mr.</option>
                    <option value="Mrs.">Mrs.</option>
                    <option value="Ms.">Ms.</option>
                    <option value="Dr.">Dr.</option>
                    <option value="M/s.">M/s.</option>
                  </select>
                </div>
                <div className="flex flex-col md:col-span-3">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Name <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    value={newCustomerForm.name}
                    onChange={(e) => setNewCustomerForm(prev => ({ ...prev, name: e.target.value }))}
                    placeholder="Customer name"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                    required
                  />
                </div>
              </div>

              {/* Phone & Secondary Phone */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Phone <span className="text-red-500">*</span></label>
                  <input
                    type="tel"
                    value={newCustomerForm.phone}
                    onChange={(e) => setNewCustomerForm(prev => ({ ...prev, phone: e.target.value }))}
                    placeholder="Phone number"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                    required
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Secondary Phone</label>
                  <input
                    type="tel"
                    value={newCustomerForm.secondaryPhone}
                    onChange={(e) => setNewCustomerForm(prev => ({ ...prev, secondaryPhone: e.target.value }))}
                    placeholder="Secondary phone"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Email & Station */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Email</label>
                  <input
                    type="email"
                    value={newCustomerForm.email}
                    onChange={(e) => setNewCustomerForm(prev => ({ ...prev, email: e.target.value }))}
                    placeholder="Email address"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Station</label>
                  <Select
                    options={stationOptions}
                    value={stationOptions.find(opt => opt.value === newCustomerForm.station)}
                    onChange={(selected) => setNewCustomerForm(prev => ({ ...prev, station: selected?.value || '' }))}
                    placeholder="Select station..."
                    isClearable
                    isLoading={loadingStations}
                    className="text-sm"
                  />
                </div>
              </div>

              {/* Pin Code */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Pin Code</label>
                  <input
                    type="text"
                    value={newCustomerForm.pinCode}
                    onChange={(e) => setNewCustomerForm(prev => ({ ...prev, pinCode: e.target.value }))}
                    placeholder="Pin code"
                    maxLength="6"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Site Address */}
              <div className="flex flex-col">
                <label className="font-semibold mb-1 text-sm text-gray-700">Site Address</label>
                <textarea
                  value={newCustomerForm.siteAddress}
                  onChange={(e) => setNewCustomerForm(prev => ({ ...prev, siteAddress: e.target.value }))}
                  placeholder="Site address"
                  rows="2"
                  className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Delivery Address */}
              <div className="flex flex-col">
                <label className="font-semibold mb-1 text-sm text-gray-700">Delivery Address</label>
                <textarea
                  value={newCustomerForm.deliveryAddress}
                  onChange={(e) => setNewCustomerForm(prev => ({ ...prev, deliveryAddress: e.target.value }))}
                  placeholder="Delivery address"
                  rows="2"
                  className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => {
                    setShowCreateCustomerModal(false);
                    setNewCustomerForm({ name: '', phone: '', secondaryPhone: '', email: '', station: '', pinCode: '', panNo: '', gstNo: '', siteAddress: '', deliveryAddress: '', salutation: '', createdBy: user?.user?._id });
                    setIsCustomerPanReadOnly(false);
                    setIsCustomerGstReadOnly(false);
                    setShowCustomerGstPanFields(false);
                  }}
                  className="px-6 py-2.5 bg-gray-500 text-white rounded-xl hover:bg-gray-600 transition-all font-semibold flex items-center gap-2"
                >
                  <FaTimes size={14} />
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isCreatingCustomer}
                  className="px-6 py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-xl hover:from-green-600 hover:to-emerald-700 transition-all font-semibold flex items-center gap-2 disabled:opacity-50"
                >
                  <FaPlus size={14} />
                  {isCreatingCustomer ? 'Creating...' : 'Create Customer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Create Dealer Modal */}
      {showCreateDealerModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[60] flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden shadow-2xl">
            <div className="bg-gradient-to-r from-orange-600 to-red-600 text-white p-6">
              <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold flex items-center gap-2">
                  <FaStore />
                  Create New Dealer
                </h2>
                <button
                  onClick={() => {
                    setShowCreateDealerModal(false);
                    setNewDealerForm({ businessName: '', businessOwner: '', phone: '', secondaryPhone: '', email: '', address: '', station: '', pinCode: '', gstNo: '', panNo: '', createdBy: user?.user?._id });
                    setIsDealerPanReadOnly(false);
                    setIsDealerGstReadOnly(false);
                    setShowDealerGstPanFields(false);
                  }}
                  className="text-white hover:text-gray-200 p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
                >
                  <FaTimes size={24} />
                </button>
              </div>
            </div>
            
            <form onSubmit={handleCreateDealer} className="p-6 overflow-y-auto max-h-[70vh] space-y-4">
              {/* GST/PAN Verification Buttons or Fields */}
              {!showDealerGstPanFields ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-sm text-gray-700">GST Verification</label>
                    <button
                      type="button"
                      onClick={() => setShowDealerGSTVerification(true)}
                      className="px-4 py-2.5 rounded-lg transition-all text-sm flex items-center justify-center space-x-2 shadow-md hover:shadow-lg bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white"
                    >
                      <span>🔍</span>
                      <span>Verify GST Number</span>
                    </button>
                    <p className="text-xs mt-1 text-gray-500">Verify GSTIN and auto-extract PAN, business details</p>
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-sm text-gray-700">PAN Verification</label>
                    <button
                      type="button"
                      onClick={() => setShowDealerPANVerification(true)}
                      className="px-4 py-2.5 rounded-lg transition-all text-sm flex items-center justify-center space-x-2 shadow-md hover:shadow-lg bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white"
                    >
                      <span>🔍</span>
                      <span>Verify PAN Number</span>
                    </button>
                    <p className="text-xs mt-1 text-gray-500">Verify PAN number independently</p>
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* GST No */}
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-gray-700">
                      GST No {isDealerGstReadOnly && <span className="text-sm text-blue-600">(Verified) 🔒</span>}
                    </label>
                    <div className="flex space-x-2">
                      <input
                        type="text"
                        value={newDealerForm.gstNo}
                        onChange={(e) => setNewDealerForm(prev => ({ ...prev, gstNo: e.target.value.toUpperCase() }))}
                        placeholder="15-digit GST number"
                        maxLength="15"
                        disabled={isDealerGstReadOnly}
                        className={`border rounded-lg p-2.5 w-full focus:outline-none focus:ring-2 focus:ring-orange-500 ${isDealerGstReadOnly ? 'bg-gray-200 text-gray-600 cursor-not-allowed' : 'bg-white'}`}
                      />
                      <button
                        type="button"
                        onClick={() => setShowDealerGSTVerification(true)}
                        disabled={isDealerGstReadOnly}
                        className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap ${isDealerGstReadOnly ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'}`}
                      >
                        {isDealerGstReadOnly ? '✅ Verified' : '🔍 Verify'}
                      </button>
                    </div>
                  </div>
                  {/* PAN No */}
                  <div className="flex flex-col">
                    <label className="font-semibold mb-1 text-gray-700">
                      PAN No {isDealerPanReadOnly && <span className="text-sm text-blue-600">(Auto-extracted) 🔒</span>}
                    </label>
                    <div className="flex space-x-2">
                      <input
                        type="text"
                        value={newDealerForm.panNo}
                        onChange={(e) => setNewDealerForm(prev => ({ ...prev, panNo: e.target.value.toUpperCase() }))}
                        placeholder="Enter PAN"
                        maxLength="10"
                        disabled={isDealerPanReadOnly}
                        className={`border rounded-lg p-2.5 w-full focus:outline-none focus:ring-2 focus:ring-orange-500 ${isDealerPanReadOnly ? 'bg-gray-200 text-gray-600 cursor-not-allowed' : 'bg-white'}`}
                      />
                      <button
                        type="button"
                        onClick={() => setShowDealerPANVerification(true)}
                        disabled={isDealerPanReadOnly}
                        className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap ${isDealerPanReadOnly ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 text-white'}`}
                      >
                        {isDealerPanReadOnly ? '✅ From GST' : '🔍 Verify'}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Business Name & Owner */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Business Name</label>
                  <input
                    type="text"
                    value={newDealerForm.businessName}
                    onChange={(e) => setNewDealerForm(prev => ({ ...prev, businessName: e.target.value }))}
                    placeholder="Business name"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Business Owner</label>
                  <input
                    type="text"
                    value={newDealerForm.businessOwner}
                    onChange={(e) => setNewDealerForm(prev => ({ ...prev, businessOwner: e.target.value }))}
                    placeholder="Business owner name"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
              </div>

              {/* Phone & Secondary Phone */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Phone <span className="text-red-500">*</span></label>
                  <input
                    type="tel"
                    value={newDealerForm.phone}
                    onChange={(e) => setNewDealerForm(prev => ({ ...prev, phone: e.target.value }))}
                    placeholder="Phone number"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                    required
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Secondary Phone</label>
                  <input
                    type="tel"
                    value={newDealerForm.secondaryPhone}
                    onChange={(e) => setNewDealerForm(prev => ({ ...prev, secondaryPhone: e.target.value }))}
                    placeholder="Secondary phone"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
              </div>

              {/* Email & Station */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Email</label>
                  <input
                    type="email"
                    value={newDealerForm.email}
                    onChange={(e) => setNewDealerForm(prev => ({ ...prev, email: e.target.value }))}
                    placeholder="Email address"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Station</label>
                  <Select
                    options={stationOptions}
                    value={stationOptions.find(opt => opt.value === newDealerForm.station)}
                    onChange={(selected) => setNewDealerForm(prev => ({ ...prev, station: selected?.value || '' }))}
                    placeholder="Select station..."
                    isClearable
                    isLoading={loadingStations}
                    className="text-sm"
                  />
                </div>
              </div>

              {/* Pin Code */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <label className="font-semibold mb-1 text-sm text-gray-700">Pin Code</label>
                  <input
                    type="text"
                    value={newDealerForm.pinCode}
                    onChange={(e) => setNewDealerForm(prev => ({ ...prev, pinCode: e.target.value }))}
                    placeholder="Pin code"
                    maxLength="6"
                    className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
              </div>

              {/* Address */}
              <div className="flex flex-col">
                <label className="font-semibold mb-1 text-sm text-gray-700">Address</label>
                <textarea
                  value={newDealerForm.address}
                  onChange={(e) => setNewDealerForm(prev => ({ ...prev, address: e.target.value }))}
                  placeholder="Full address"
                  rows="2"
                  className="border rounded-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-orange-500"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => {
                    setShowCreateDealerModal(false);
                    setNewDealerForm({ businessName: '', businessOwner: '', phone: '', secondaryPhone: '', email: '', address: '', station: '', pinCode: '', gstNo: '', panNo: '', createdBy: user?.user?._id });
                    setIsDealerPanReadOnly(false);
                    setIsDealerGstReadOnly(false);
                    setShowDealerGstPanFields(false);
                  }}
                  className="px-6 py-2.5 bg-gray-500 text-white rounded-xl hover:bg-gray-600 transition-all font-semibold flex items-center gap-2"
                >
                  <FaTimes size={14} />
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isCreatingDealer}
                  className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-xl hover:from-orange-600 hover:to-red-600 transition-all font-semibold flex items-center gap-2 disabled:opacity-50"
                >
                  <FaPlus size={14} />
                  {isCreatingDealer ? 'Creating...' : 'Create Dealer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Customer GST Verification Modal */}
      <GSTVerificationModal
        isOpen={showCustomerGSTVerification}
        onClose={() => setShowCustomerGSTVerification(false)}
        onDataReceived={handleCustomerGSTVerificationData}
        initialGSTIN={newCustomerForm.gstNo}
      />

      {/* Customer PAN Verification Modal */}
      <PANVerificationModal
        isOpen={showCustomerPANVerification}
        onClose={() => setShowCustomerPANVerification(false)}
        onDataReceived={handleCustomerPANVerificationData}
        initialPAN={newCustomerForm.panNo}
      />

      {/* Dealer GST Verification Modal */}
      <GSTVerificationModal
        isOpen={showDealerGSTVerification}
        onClose={() => setShowDealerGSTVerification(false)}
        onDataReceived={handleDealerGSTVerificationData}
        initialGSTIN={newDealerForm.gstNo}
      />

      {/* Dealer PAN Verification Modal */}
      <PANVerificationModal
        isOpen={showDealerPANVerification}
        onClose={() => setShowDealerPANVerification(false)}
        onDataReceived={handleDealerPANVerificationData}
        initialPAN={newDealerForm.panNo}
      />

    </div>
  );
};

export default ChoiceEntry;
